<template>
  <div class="profile" v-if="show_settings">
    <div class="profile-bg" @click="closeSettings"></div>
    <div class="profile__content">
      <div class="profile__close" @click="closeSettings">
        <i class="el-icon-close"></i>
      </div>
      <div class="profile__content__leftbar">
        <div class="profile__content__avatar">
          <span
            :style="'background-color: ' + getUserData.color"
            v-html="user_image"
          ></span>
          <p>{{ getUserData.name }}</p>
        </div>
        <ul>
          <li
            @click="tab = 'profile'"
            :class="tab == 'profile' ? 'active' : ''"
            v-html="account"
          ></li>
          <li
            @click="tab = 'setting'"
            :class="tab == 'setting' ? 'active' : ''"
          >
            {{ $t('settings.general.title') }}
          </li>
          <li @click="tab = 'theme'" :class="tab == 'theme' ? 'active' : ''">
            {{ $t('settings.theme.title') }}
          </li>
          <li
            @click="tab = 'shortcuts'"
            :class="tab == 'shortcuts' ? 'active' : ''"
          >
            {{ $t('settings.shortcuts.title') }}
          </li>
          <!-- <li @click="tab = 'lists'" :class="tab == 'lists' ? 'active' : ''">Lists</li>
          <li @click="tab = 'chats'" :class="tab == 'chats' ? 'active' : ''">Chats</li> -->
          <!-- <li @click="tab = 'app_downloads'" :class="tab == 'app_downloads' ? 'active' : ''">App downloads</li> -->
          <li @click="tab = 'usage'" :class="tab == 'usage' ? 'active' : ''">
            {{ $t('settings.usage.title') }}
          </li>
          <!-- <li @click="tab = 'upgrade'" :class="tab == 'upgrade' ? 'active' : ''">Upgrade</li> -->
          <li @click="tab = 'import'" :class="tab == 'import' ? 'active' : ''">
            {{ $t('settings.import.title') }}
          </li>
<!--           <li-->
<!--            @click="tab = 'backups'"-->
<!--            :class="tab == 'backups' ? 'active' : ''"-->
<!--          >-->
<!--            Backups-->
<!--          </li>-->
          <li
            @click="tab = 'support'"
            :class="tab == 'support' ? 'active' : ''"
          >
            {{ $t('settings.support.title') }}
          </li>
        </ul>
      </div>
      <div
        class="profile__content__block profile-content"
        :class="{ show: tab == 'profile' }"
        v-if="
          tab == 'profile' || tab == 'change_password' || tab == 'change_email'
        "
      >
        <div class="profile__content__title">{{ $t('settings.profile.title') }}</div>
        <div class="profile__content__form">
          <div class="profile__content__upload">
            <div>
              <label v-if="getUserData.image">
                <input
                  type="file"
                  @input="fileUpload($event)"
                  accept="image/jpeg,image/jpg,image/png"
                />
                {{ text_file ? text_file : $t('settings.profile.file.change') }}
              </label>
              <label v-else>
                <input
                  type="file"
                  @input="fileUpload($event)"
                  accept="image/jpeg,image/jpg,image/png"
                />
                {{ text_file ? text_file : $t('settings.profile.file.upload') }}
              </label>
              <p class="max-size">{{ $t('settings.profile.file.max_size') }}</p>
            </div>
            <button v-if="getUserData.image" @click="avatarRemove">
              {{ $t('settings.profile.file.remove') }}
            </button>
          </div>
          <div class="input">
            <label>
              <span>{{ $t('settings.profile.forms.name.label') }}</span>
              <input type="text" v-model="user_name" max="25" />
            </label>
            <button @click="saveUserName">{{ $t('settings.profile.forms.name.button') }}</button>
          </div>
          <div class="input">
            <label>
              <span>
                {{ $t('settings.profile.forms.email.label') }}
                <span v-if="!getUserData.verification">{{ $t('settings.profile.forms.email.not_verified') }}</span>
                <div class="account__verified" v-if="getUserData.verification">
                  {{ $t('settings.profile.forms.email.verify') }}
                </div>
              </span>
              <input type="email" :value="getUserData.email" disabled />
            </label>
            <button v-if="getUserData.password" @click="tab = 'change_email'">
              {{ $t('settings.profile.forms.email.button') }}
            </button>
            <button
              v-else
              @click="
                setMessage({
                  key_message: 'warning',
                  message: 'You need to add a password first.',
                })
              "
            >
              {{ $t('settings.profile.forms.email.button') }}
            </button>
            <button
              class="red"
              @click="Verification"
              v-if="!userData.verification && !send_verification"
            >
              {{ $t('settings.profile.forms.email.verify_button') }}
            </button>
            <div
              v-if="send_verification && !change_verification"
              class="send_verification"
            >
              <p>{{ $t('settings.profile.verification.text') }}</p>
              <span
                >{{ $t('settings.profile.verification.not') }}
                <span
                  @click="Verification"
                  :style="send_verification_button ? '' : 'opacity: 0.5'"
                  >{{ $t('settings.profile.verification.button') }}</span
                ></span
              >
            </div>
          </div>
          <div class="input">
            <label v-if="getUserData.password">
              <span>{{ $t('settings.profile.forms.password.label') }}</span>
              <input type="password" disabled />
              <p class="input_password">••••••••••</p>
            </label>
            <label v-else>
              <span>{{ $t('settings.profile.forms.password.add_password') }}</span>
              <input
                class="add_password"
                :type="show_password ? 'text' : 'password'"
                v-model="change_password.new_password"
              />

              <svg
                v-if="!show_password"
                @click="show_password = true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                aria-hidden="true"
              >
                <g fill="none" fill-rule="evenodd" stroke="gray">
                  <path
                    d="M21.358 12C17.825 7.65 14.692 5.5 12 5.5c-2.624 0-5.67 2.043-9.097 6.181a.5.5 0 0 0 0 .638C6.331 16.457 9.376 18.5 12 18.5c2.692 0 5.825-2.15 9.358-6.5z"
                  ></path>
                  <circle cx="12" cy="12" r="3.5"></circle>
                </g>
              </svg>
              <svg
                v-else
                @click="show_password = false"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                aria-hidden="true"
              >
                <g fill="gray" fill-rule="evenodd" transform="translate(2 4)">
                  <path
                    fill-rule="nonzero"
                    d="M13.047 2.888C11.962 2.294 10.944 2 10 2 7.56 2 4.63 3.966 1.288 8c1.133 1.368 2.218 2.497 3.253 3.394l-.708.708c-1.068-.93-2.173-2.085-3.315-3.464a1 1 0 0 1 0-1.276C4.031 3.121 7.192 1 10 1c1.196 0 2.456.385 3.78 1.154l-.733.734zm-6.02 10.263C8.084 13.72 9.076 14 10 14c2.443 0 5.373-1.969 8.712-6-1.11-1.34-2.176-2.453-3.193-3.341l.708-.709C17.437 5.013 18.695 6.363 20 8c-3.721 4.667-7.054 7-10 7-1.175 0-2.411-.371-3.709-1.113l.735-.736z"
                  ></path>
                  <path
                    fill-rule="nonzero"
                    d="M8.478 11.7l.79-.79a3 3 0 0 0 3.642-3.642l.79-.79A4 4 0 0 1 8.477 11.7zM6.334 9.602a4 4 0 0 1 5.268-5.268l-.78.78A3.002 3.002 0 0 0 7.113 8.82l-.78.78z"
                  ></path>
                  <rect
                    width="21"
                    height="1"
                    x="-.722"
                    y="7.778"
                    rx=".5"
                    transform="rotate(-45 9.778 8.278)"
                  ></rect>
                </g>
              </svg>
            </label>
            <button
              v-if="getUserData.password"
              @click="tab = 'change_password'"
            >
              {{ $t('settings.profile.forms.password.button') }}
            </button>
            <button v-else @click="addPassword">{{ $t('settings.profile.forms.password.button_add') }}</button>
          </div>
          <button class="delete_button" @click="tab = 'delete-account'">{{ $t('settings.profile.delete_button') }}</button>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'setting'">
        <div class="profile__content__title">{{ $t('settings.general.title') }}</div>
        <div class="profile__content__form general">
          <div class="profile__select">
            <label>
              <span>
                {{ $t('settings.general.selects.language.label') }}
                <!-- <span>Coming Soon!</span> -->
              </span>
              <select
                v-model="select.lang"
                @change="saveSettings('language')"
              >
                <option value="en">English</option>
                <option value="de">Deutsch</option>
                <option value="pl">Polski</option>
                <option value="cz">Čeština</option>
                <option value="ru">Русский</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.homepage.label') }}</span>
              <select v-model="select.home" @change="saveSettings('shortcuts')">
                <option
                  v-for="item of getUserData.shortcuts"
                  :key="item.type"
                  :value="item.type"
                >
                  {{ shortcuts(item.type) }}
                </option>
                <optgroup :label="$t('tabs.lists')" v-if="getProjects.length > 0">
                  <option
                    v-for="project of getProjects"
                    :key="project._id"
                    :value="project._id"
                    :style="
                      project._id == getUserData.shortcut_inbox
                        ? 'display: none'
                        : ''
                    "
                  >
                    {{ project.name }}
                  </option>
                </optgroup>
                <optgroup :label="$t('tabs.chats')" v-if="getChatsExcluded.length > 0">
                  <option
                    v-for="chat of getChatsExcluded"
                    :key="chat._id"
                    :value="chat._id"
                  >
                    {{ chat.name }}
                  </option>
                </optgroup>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.date_format.label') }}</span>
              <select
                v-model="select.date"
                @change="saveSettings('date_format')"
              >
                <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.time_format.label') }}</span>
              <select
                v-model="select.time"
                @change="saveSettings('time_format')"
              >
                <option value="1:00 PM">1:00 PM</option>
                <option value="13:00">13:00</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.start_week.label') }}</span>
              <select
                v-model="select.week"
                @change="saveSettings('start_of_the_week')"
              >
                <option value="Monday">{{ $t('settings.general.selects.start_week.options.monday') }}</option>
                <option value="Sunday">{{ $t('settings.general.selects.start_week.options.sunday') }}</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.expand_subtasks.label') }}</span>
              <select
                v-model="select.subtask"
                @change="saveSettings('expand_subtask')"
              >
                <option value="Enabled">{{ $t('settings.general.selects.expand_subtasks.options.enabled') }}</option>
                <option value="Disabled">{{ $t('settings.general.selects.expand_subtasks.options.disabled') }}</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
          <div class="profile__select">
            <label>
              <span>{{ $t('settings.general.selects.add_tasks.label') }}</span>
              <select
                v-model="select.new_task"
                @change="saveSettings('new_task')"
              >
                <option value="top">{{ $t('settings.general.selects.add_tasks.options.top') }}</option>
                <option value="bottom">{{ $t('settings.general.selects.add_tasks.options.bottom') }}</option>
              </select>
              <img
                :src="require(`@/assets/static/images/arrow-select.svg`)"
                alt=""
              />
            </label>
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'theme'">
        <ul class="profile__content__tabs">
          <li @click="changeThemeTab('background-image')">{{ $t('settings.theme.tabs.background_image.title') }}</li>
          <li @click="changeThemeTab('themes')">{{ $t('settings.theme.tabs.colour_scheme.title') }}</li>
        </ul>
        <div v-if="activeThemeTab == 'background-image'" class="profile__content__form" style="padding: 0px">
          <div
            class="profile__content__upload"
            style="padding: 0 0 25px; margin: 45px 65px 0"
          >
            <div>
              <label
                v-if="
                  !background_images.some(
                    (e) => e.image_name == getUserData.background_image
                  )
                "
              >
                <input
                  type="file"
                  @input="uploadBackgroundImage"
                  accept="image/jpeg,image/jpg,image/png"
                />
                {{ text_file ? text_file : $t('settings.theme.tabs.background_image.file.change') }}
              </label>
              <label v-else>
                <input
                  type="file"
                  @input="uploadBackgroundImage"
                  accept="image/jpeg,image/jpg,image/png"
                />
                {{ text_file ? text_file : $t('settings.theme.tabs.background_image.file.upload') }}
              </label>
              <p class="max-size">{{ $t('settings.theme.tabs.background_image.file.max_size') }}</p>
            </div>
            <button
              v-if="
                !background_images.some(
                  (e) => e.image_name == getUserData.background_image
                )
              "
              @click="removeBackgroundImage"
            >
              {{ $t('settings.theme.tabs.background_image.file.remove') }}
            </button>
          </div>
          <div
            class="profile__content__background-item"
            style="padding: 40px 65px 0; overflow-y: auto; height: 430px"
          >
            <div
              v-for="image of background_images"
              :key="image.title"
              :class="
                background_image == image.image_name
                  ? 'active background-item__block'
                  : 'background-item__block'
              "
              @click="changeBackgroundImage(image)"
            >
              <div
                v-if="image.color"
                :style="'background-color: ' + image.color"
              ></div>
              <img
                v-else
                :src="
                  require('@/assets/static/images/bg/200/200 ' +
                    image.image_name)
                "
              />
              <span>{{ image.title }}</span>
            </div>
          </div>
        </div>
        <div v-if="activeThemeTab == 'themes'" class="profile__content__form" style="padding: 0px">
          <Themes></Themes>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'shortcuts'">
        <div class="profile__content__title">{{ $t('settings.shortcuts.title') }}</div>
        <div class="shortcut shortcut_block">
          <div class="shortcut__list">
            <div class="shortcut__list__content">
              <div
                class="shortcut__list__content__icon"
                style="background-color: #b86a6f"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_0_191)">
                    <path
                      d="M15.7905 0.476196H4.20953C2.14767 0.476196 0.476196 2.14767 0.476196 4.20953V15.7905C0.476196 17.8523 2.14767 19.5238 4.20953 19.5238H15.7905C17.8523 19.5238 19.5238 17.8523 19.5238 15.7905V4.20953C19.5238 2.14767 17.8523 0.476196 15.7905 0.476196Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M19.5238 12.7619H11.8095"
                      stroke="white"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7.4381 12.7619H0.476196"
                      stroke="white"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7.43811 12.7619C7.41835 13.0611 7.46022 13.3611 7.56112 13.6434C7.66202 13.9258 7.8198 14.1844 8.0247 14.4033C8.2296 14.6221 8.47725 14.7966 8.75232 14.9159C9.02738 15.0352 9.32401 15.0967 9.62383 15.0967C9.92364 15.0967 10.2203 15.0352 10.4953 14.9159C10.7704 14.7966 11.0181 14.6221 11.223 14.4033C11.4278 14.1844 11.5856 13.9258 11.6865 13.6434C11.7874 13.3611 11.8293 13.0611 11.8095 12.7619"
                      stroke="white"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_191">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>{{ $t('app.shortcuts.inbox') }}</p>
            </div>
            <div>
              <label class="radio" for="radio__toggle5">
                <input
                  class="radio__toggle"
                  id="radio__toggle5"
                  type="checkbox"
                  v-model="checkbox.inbox"
                  @change="changeBox('inbox')"
                />
              </label>
            </div>
          </div>
          <div class="shortcut__list">
            <div class="shortcut__list__content">
              <div
                class="shortcut__list__content__icon"
                style="background-color: #f2a7a7"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_0_170)">
                    <path
                      d="M7.04761 2.49524H8.05713H12.0571H12.9524"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M15.0381 2.49524H16.7048C17.0584 2.47202 17.4131 2.51901 17.7484 2.6335C18.0838 2.74799 18.3932 2.92771 18.6588 3.16232C18.9244 3.39692 19.1409 3.68176 19.2959 4.00043C19.4509 4.31909 19.5413 4.66529 19.5619 5.01905V6.80953H0.476196V5.01905C0.496797 4.66529 0.587204 4.31909 0.742207 4.00043C0.89721 3.68176 1.11374 3.39692 1.37933 3.16232C1.64492 2.92771 1.95431 2.74799 2.28967 2.6335C2.62503 2.51901 2.97974 2.47202 3.33334 2.49524H4.96191"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M19.5238 6.80951V17C19.5032 17.3538 19.4128 17.6999 19.2578 18.0186C19.1028 18.3373 18.8863 18.6221 18.6207 18.8567C18.3551 19.0913 18.0457 19.271 17.7104 19.3855C17.375 19.5 17.0203 19.547 16.6667 19.5238H3.29525C2.94165 19.547 2.58695 19.5 2.25158 19.3855C1.91622 19.271 1.60683 19.0913 1.34125 18.8567C1.07566 18.6221 0.859124 18.3373 0.704121 18.0186C0.549118 17.6999 0.458711 17.3538 0.43811 17V6.80951H19.5238Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M7.04764 1.40952V3.58095C7.04818 3.71357 7.02101 3.84484 6.96788 3.96635C6.91475 4.08786 6.83683 4.19694 6.73911 4.2866C6.64138 4.37625 6.52601 4.44451 6.40038 4.487C6.27475 4.52948 6.14163 4.54526 6.00954 4.53333C5.87671 4.54668 5.74255 4.53196 5.61578 4.49011C5.489 4.44826 5.37244 4.38023 5.27365 4.29043C5.17487 4.20062 5.09607 4.09105 5.04237 3.96883C4.98866 3.8466 4.96126 3.71445 4.96193 3.58095V1.40952C4.96126 1.27602 4.98866 1.14386 5.04237 1.02164C5.09607 0.899413 5.17487 0.789843 5.27365 0.700038C5.37244 0.610234 5.489 0.542202 5.61578 0.500356C5.74255 0.45851 5.87671 0.443785 6.00954 0.457137C6.27969 0.45561 6.54086 0.553975 6.74288 0.733328C6.84107 0.816021 6.91944 0.919715 6.97219 1.03675C7.02493 1.15379 7.05072 1.28118 7.04764 1.40952V1.40952Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M15.0381 1.40952V3.58095C15.0133 3.84034 14.8927 4.08117 14.6999 4.25643C14.5071 4.43169 14.2558 4.5288 13.9953 4.5288C13.7347 4.5288 13.4835 4.43169 13.2906 4.25643C13.0978 4.08117 12.9772 3.84034 12.9524 3.58095V1.40952C12.9519 1.2769 12.979 1.14563 13.0322 1.02412C13.0853 0.902608 13.1632 0.79353 13.2609 0.703874C13.3587 0.614219 13.474 0.545961 13.5997 0.503474C13.7253 0.460987 13.8584 0.445206 13.9905 0.457143C14.2636 0.455061 14.5279 0.553346 14.7334 0.733334C14.8295 0.817721 14.9065 0.92174 14.9591 1.03838C15.0116 1.15503 15.0386 1.28158 15.0381 1.40952V1.40952Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_170">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ nowDay() }}</span>
              </div>
              <p>{{ $t('app.shortcuts.today') }}</p>
            </div>
            <div>
              <label class="radio" for="radio__toggle4">
                <input
                  class="radio__toggle"
                  id="radio__toggle4"
                  type="checkbox"
                  v-model="checkbox.today"
                  @change="changeBox('today')"
                />
              </label>
            </div>
          </div>
          <div class="shortcut__list">
            <div class="shortcut__list__content">
              <div
                class="shortcut__list__content__icon"
                style="background-color: #e3b5b5"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_0_181)">
                    <path
                      d="M15.7905 0.476196H4.20953C2.14767 0.476196 0.476196 2.14767 0.476196 4.20953V15.7905C0.476196 17.8523 2.14767 19.5238 4.20953 19.5238H15.7905C17.8523 19.5238 19.5238 17.8523 19.5238 15.7905V4.20953C19.5238 2.14767 17.8523 0.476196 15.7905 0.476196Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M10 16.3238C13.4926 16.3238 16.3238 13.4925 16.3238 9.99999C16.3238 6.50744 13.4926 3.67618 10 3.67618C6.50747 3.67618 3.67621 6.50744 3.67621 9.99999C3.67621 13.4925 6.50747 16.3238 10 16.3238Z"
                      stroke="white"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M6.78094 9.27618L9.40952 11.9048"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.40955 11.9048L13.2191 8.09525"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_181">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>{{ $t('app.shortcuts.assigned_to_me') }}</p>
            </div>
            <div>
              <label class="radio" for="radio__toggle3">
                <input
                  class="radio__toggle"
                  id="radio__toggle3"
                  type="checkbox"
                  v-model="checkbox.assigned_to_me"
                  @change="changeBox('assigned_to_me')"
                />
              </label>
            </div>
          </div>
          <div class="shortcut__list">
            <div class="shortcut__list__content">
              <div
                class="shortcut__list__content__icon"
                style="background-color: #e8cca2"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.46 0.5H3.54C1.86105 0.5 0.5 1.86105 0.5 3.54V17.46C0.5 19.1389 1.86105 20.5 3.54 20.5H17.46C19.1389 20.5 20.5 19.1389 20.5 17.46V3.54C20.5 1.86105 19.1389 0.5 17.46 0.5Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M4.68998 12.02C5.52946 12.02 6.20998 11.3395 6.20998 10.5C6.20998 9.66052 5.52946 8.98 4.68998 8.98C3.85051 8.98 3.16998 9.66052 3.16998 10.5C3.16998 11.3395 3.85051 12.02 4.68998 12.02Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M10.5 12.02C11.3395 12.02 12.02 11.3395 12.02 10.5C12.02 9.66052 11.3395 8.98 10.5 8.98C9.66051 8.98 8.97998 9.66052 8.97998 10.5C8.97998 11.3395 9.66051 12.02 10.5 12.02Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M16.31 12.02C17.1495 12.02 17.83 11.3395 17.83 10.5C17.83 9.66052 17.1495 8.98 16.31 8.98C15.4705 8.98 14.79 9.66052 14.79 10.5C14.79 11.3395 15.4705 12.02 16.31 12.02Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                </svg>
              </div>
              <p>{{ $t('app.shortcuts.medium_priority') }}</p>
            </div>
            <div>
              <label class="radio" for="radio__toggle2">
                <input
                  class="radio__toggle"
                  id="radio__toggle2"
                  type="checkbox"
                  v-model="checkbox.medium_priority"
                  @change="changeBox('medium_priority')"
                />
              </label>
            </div>
          </div>
          <div class="shortcut__list">
            <div class="shortcut__list__content">
              <div
                class="shortcut__list__content__icon"
                style="background-color: #fc8785"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.46 0.5H3.54C1.86105 0.5 0.5 1.86105 0.5 3.54V17.46C0.5 19.1389 1.86105 20.5 3.54 20.5H17.46C19.1389 20.5 20.5 19.1389 20.5 17.46V3.54C20.5 1.86105 19.1389 0.5 17.46 0.5Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M10.51 2.52H10.5C9.70471 2.52 9.06 3.16471 9.06 3.96V12.8C9.06 13.5953 9.70471 14.24 10.5 14.24H10.51C11.3053 14.24 11.95 13.5953 11.95 12.8V3.96C11.95 3.16471 11.3053 2.52 10.51 2.52Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M10.5 18.48C11.2953 18.48 11.94 17.8353 11.94 17.04C11.94 16.2447 11.2953 15.6 10.5 15.6C9.70471 15.6 9.06 16.2447 9.06 17.04C9.06 17.8353 9.70471 18.48 10.5 18.48Z"
                    stroke="white"
                    stroke-miterlimit="10"
                  />
                </svg>
              </div>
              <p>{{ $t('app.shortcuts.high_priority') }}</p>
            </div>
            <div>
              <label class="radio" for="radio__toggle1">
                <input
                  class="radio__toggle"
                  id="radio__toggle1"
                  type="checkbox"
                  v-model="checkbox.high_priority"
                  @change="changeBox('high_priority')"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'upgrade'">
        <div class="profile__content__title">
          {{ $t('settings.upgrade.title') }} (Your current plan is {{ this.getPlan.name }})
        </div>

        <div class="upgrade-content" v-if="plans">
          <div
            v-for="plan in getAllPlan"
            :key="plan._id"
            class="upgrade-content__item dark"
          >
            <div class="upgrade-content__item__block">
              <div class="upgrade-content__item__text">
                <span>{{ plan.name }}</span>
                <p>${{ plan.price }}</p>
              </div>
              <div class="upgrade-content__item__button">
                <button @click="setMonthlyPlan(plan._id)">Monthly</button>
                <button @click="setYearlyPlan(plan._id)">Yearly</button>
              </div>
            </div>
            <a
              href="https://taskpal.com/pricing"
              target="_blank"
              class="btn btn-block"
            >
              <p>Full plan details</p>
            </a>
            <template
              v-if="
                getUserData.downgrade_plan && getUserData.downgrade_plan.plan_id
              "
            >
              <button
                v-if="plan._id == getUserData.downgrade_plan.plan_id"
                class="btn cyan disable"
              >
                Starting from
                {{
                  $w_date_parse(getUserData.downgrade_plan.date) +
                  ', ' +
                  $w_time_parse(
                    getUserData.downgrade_plan.date,
                    getUserData.date_format.time
                  )
                }}
              </button>
              <button
                v-if="plan._id != getUserData.downgrade_plan.plan_id"
                class="btn cyan disable"
              >
                {{
                  'Switched to ' +
                  plans.find((e) => e._id == getUserData.downgrade_plan.plan_id)
                    .name
                }}
              </button>
            </template>
            <template v-else>
              <button
                v-if="plan._id != current_plan_id"
                class="btn cyan"
                @click.prevent="subscribe(plan)"
              >
                Subscribe
              </button>
              <button
                v-if="plan._id == current_plan_id"
                class="btn cyan"
                @click.prevent="unsubscribe(plan)"
              >
                Cancel Subscription
              </button>
            </template>
          </div>

          <div class="stripe_popups">
            <div class="account_details">
              <button
                type="button"
                @click.prevent="closeStripePopup"
                class="close_stripe"
              >
                <img
                  :src="require(`@/assets/static/images/close.svg`)"
                  alt=""
                />
              </button>
              <form @submit.prevent="subscribeToPlan">
                <div class="form-blocks">
                  <div>
                    <h2>{{ this.formData[this.formNumber].title }}</h2>
                    <span
                      v-if="this.formNumber == 0"
                      class="three_dots first"
                    ></span>
                    <span
                      v-else-if="this.formNumber == 1"
                      class="three_dots second"
                    ></span>
                    <span
                      v-else-if="this.formNumber == 2"
                      class="three_dots third"
                    ></span>
                  </div>
                </div>

                <div class="form-blocks">
                  <div>
                    <div class="plan_info">
                      Membership {{ this.current_plan.name }} -
                      {{
                        this.current_plan.price !=
                        this.real_prices[this.current_plan._id]
                          ? 'Yearly'
                          : 'Monthly'
                      }}
                      <span
                        v-if="
                          this.current_plan.price !=
                          this.real_prices[this.current_plan._id]
                        "
                        >${{
                          new_price
                            ? new_price
                            : this.current_plan.price + '.00'
                        }}</span
                      >
                      <span v-else
                        >${{
                          new_price
                            ? new_price
                            : this.current_plan.price + '.00'
                        }}</span
                      >
                    </div>
                  </div>
                </div>

                <div v-if="this.formNumber == 0" class="form-blocks group">
                  <div>
                    <input
                      v-model="formInputs.name"
                      type="text"
                      name="name"
                      placeholder="First Name"
                      data-placeholder="First Name"
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      name="sname"
                      placeholder="Last Name (Optional)"
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 0" class="form-blocks">
                  <div>
                    <input
                      v-model="formInputs.email"
                      type="email"
                      name="email"
                      placeholder="Email"
                      disabled
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 0" class="form-blocks">
                  <div>
                    <input
                      type="text"
                      name="company"
                      placeholder="Company (Optional)"
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 0" class="form-blocks">
                  <div>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone (Optional)"
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 0" class="form-blocks">
                  <div style="display: flex; flex-wrap: nowrap">
                    <input
                      type="text"
                      name="coupon"
                      placeholder="Coupon code"
                      v-model="coupon_code"
                    />
                    <div
                      @click="couponCodeSend"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 70px;
                        background-color: #2196f3;
                        color: #fff;
                        cursor: pointer;
                      "
                    >
                      Apply
                    </div>
                  </div>
                </div>

                <div v-if="this.formNumber == 1" class="form-blocks">
                  <div>
                    <input
                      v-model="formInputs.address.city"
                      type="text"
                      name="city"
                      placeholder="City"
                    />
                  </div>

                  <div>
                    <input
                      v-model="formInputs.address.country"
                      type="text"
                      name="country"
                      placeholder="Country"
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 1" class="form-blocks">
                  <div>
                    <input
                      v-model="formInputs.address.line1"
                      type="text"
                      name="address"
                      placeholder="Address"
                    />
                  </div>
                </div>
                <div v-if="this.formNumber == 1" class="form-blocks">
                  <div>
                    <input
                      v-model="formInputs.address.state"
                      type="text"
                      name="state"
                      placeholder="State"
                    />
                  </div>

                  <div>
                    <input
                      v-model="formInputs.address.postal_code"
                      type="text"
                      name="postalcode"
                      placeholder="Postal code"
                    />
                  </div>
                </div>

                <p
                  v-if="message_warn"
                  style="
                    font-size: 14px;
                    color: red;
                    padding: 10px 1.2em;
                    background: #f4f4f4;
                  "
                >
                  {{ message_warn }}
                </p>

                <div v-if="this.formNumber == 2" class="form-blocks">
                  <div class="stripe_loading">
                    <img
                      :src="require(`@/assets/static/images/loading.gif`)"
                      alt=""
                    />
                  </div>
                </div>
                <!--                  <div v-if="this.formNumber == 1">-->
                <!--                    <div>-->
                <!--                      <input type="checkbox" v-model="differentShippingAddress">-->
                <!--                      <p>Use another address to shipping</p>-->
                <!--                    </div>-->
                <!--                  </div>-->

                <!--                <div v-if="this.formNumber == 2" class="form-blocks">-->
                <!--                  <div>-->
                <!--                    <input v-model="formInputs.shipping.address.city" type="text" name="city" placeholder="City">-->
                <!--                  </div>-->

                <!--                  <div>-->
                <!--                    <input v-model="formInputs.shipping.address.country" type="text" name="country" placeholder="Country">-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div v-if="this.formNumber == 2" class="form-blocks">-->
                <!--                  <div>-->
                <!--                    <input v-model="formInputs.shipping.address.line1" type="text" name="address" placeholder="Address">-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div v-if="this.formNumber == 2" class="form-blocks">-->
                <!--                  <div>-->
                <!--                    <input v-model="formInputs.shipping.address.state" type="text" name="state" placeholder="State">-->
                <!--                  </div>-->

                <!--                  <div>-->
                <!--                    <input v-model="formInputs.shipping.address.postal_code" type="text" name="postalcode" placeholder="Postal code">-->
                <!--                  </div>-->
                <!--                </div>-->

                <div class="form-blocks">
                  <button type="submit" v-if="this.formNumber < 2">Next</button>
                </div>
              </form>
            </div>

            <div class="plan_popup">
              <form id="payment-form" @submit.prevent="sendStripeForm()">
                <button
                  type="button"
                  @click.prevent="closeStripePaymentPopup"
                  class="close_stripe"
                >
                  <img
                    :src="require(`@/assets/static/images/close.svg`)"
                    alt=""
                  />
                </button>

                <div class="logo">
                  <svg
                    width="512px"
                    height="214px"
                    viewBox="0 0 512 214"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M35.9822222,83.4844444 C35.9822222,77.9377778 40.5333333,75.8044444 48.0711111,75.8044444 C58.88,75.8044444 72.5333333,79.0755556 83.3422222,84.9066667 L83.3422222,51.4844444 C71.5377778,46.7911111 59.8755556,44.9422222 48.0711111,44.9422222 C19.2,44.9422222 0,60.0177778 0,85.1911111 C0,124.444444 54.0444444,118.186667 54.0444444,135.111111 C54.0444444,141.653333 48.3555556,143.786667 40.3911111,143.786667 C28.5866667,143.786667 13.5111111,138.951111 1.56444444,132.408889 L1.56444444,166.257778 C14.7911111,171.946667 28.16,174.364444 40.3911111,174.364444 C69.9733333,174.364444 90.3111111,159.715556 90.3111111,134.257778 C90.1688889,91.8755556 35.9822222,99.4133333 35.9822222,83.4844444 Z M132.124444,16.4977778 L97.4222222,23.8933333 L97.28,137.813333 C97.28,158.862222 113.066667,174.364444 134.115556,174.364444 C145.777778,174.364444 154.311111,172.231111 159.004444,169.671111 L159.004444,140.8 C154.453333,142.648889 131.982222,149.191111 131.982222,128.142222 L131.982222,77.6533333 L159.004444,77.6533333 L159.004444,47.36 L131.982222,47.36 L132.124444,16.4977778 Z M203.235556,57.8844444 L200.96,47.36 L170.24,47.36 L170.24,171.804444 L205.795556,171.804444 L205.795556,87.4666667 C214.186667,76.5155556 228.408889,78.5066667 232.817778,80.0711111 L232.817778,47.36 C228.266667,45.6533333 211.626667,42.5244444 203.235556,57.8844444 Z M241.493333,47.36 L277.191111,47.36 L277.191111,171.804444 L241.493333,171.804444 L241.493333,47.36 Z M241.493333,36.5511111 L277.191111,28.8711111 L277.191111,0 L241.493333,7.53777778 L241.493333,36.5511111 Z M351.431111,44.9422222 C337.493333,44.9422222 328.533333,51.4844444 323.555556,56.0355556 L321.706667,47.2177778 L290.417778,47.2177778 L290.417778,213.048889 L325.973333,205.511111 L326.115556,165.262222 C331.235556,168.96 338.773333,174.222222 351.288889,174.222222 C376.746667,174.222222 399.928889,153.742222 399.928889,108.657778 C399.786667,67.4133333 376.32,44.9422222 351.431111,44.9422222 Z M342.897778,142.933333 C334.506667,142.933333 329.528889,139.946667 326.115556,136.248889 L325.973333,83.4844444 C329.671111,79.36 334.791111,76.5155556 342.897778,76.5155556 C355.84,76.5155556 364.8,91.0222222 364.8,109.653333 C364.8,128.711111 355.982222,142.933333 342.897778,142.933333 Z M512,110.08 C512,73.6711111 494.364444,44.9422222 460.657778,44.9422222 C426.808889,44.9422222 406.328889,73.6711111 406.328889,109.795556 C406.328889,152.604444 430.506667,174.222222 465.208889,174.222222 C482.133333,174.222222 494.933333,170.382222 504.604444,164.977778 L504.604444,136.533333 C494.933333,141.368889 483.84,144.355556 469.76,144.355556 C455.964444,144.355556 443.733333,139.52 442.168889,122.737778 L511.715556,122.737778 C511.715556,120.888889 512,113.493333 512,110.08 Z M441.742222,96.5688889 C441.742222,80.4977778 451.555556,73.8133333 460.515556,73.8133333 C469.191111,73.8133333 478.435556,80.4977778 478.435556,96.5688889 L441.742222,96.5688889 L441.742222,96.5688889 Z"
                        fill="#6772E5"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div id="payment-element">
                  <div class="stripe_loading">
                    <img
                      :src="require(`@/assets/static/images/loading.gif`)"
                      alt=""
                    />
                  </div>
                  <!-- Elements will create form elements here -->
                </div>
                <button id="submit">Pay</button>
                <div id="error-message">
                  <!-- Display error message to your customers here -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="profile__content__block usage" v-else-if="tab == 'usage'">
        <div class="profile__content__title usage__title">
          {{ $t('settings.usage.title') }} 
          <!-- {{ this.getPlan.name }} plan -->
        </div>
        <div class="usage__content">
          <div v-for="item in usageList" :key="item.name" class="usage__item">
            <p class="usage__item-title">
              {{ item.name }} ({{ item.max ? $t('settings.usage.used') : $t('settings.usage.allowed') }})
            </p>
            <!-- {{item}} -->
            <p class="usage__item-stats">
              {{ item.current }}{{ item.max ? '/' + item.max : '' }}
            </p>
          </div>

          <div class="usage__disk">
            <label for="showDiskUsage">{{ $t('settings.usage.show_disk_space_sidebar') }} </label>
            <input
              type="checkbox"
              @click="toggleShowDiskUsageInSidebar"
              class="standart_checkbox"
              :checked="showDiskUsageInSidebar"
            />
            <!-- <div class="input-holder" @click="toggleShowDiskUsageInSidebar">
              <div class="empty" id="showDiskUsage"></div>
              <!- <input id="showDiskUsage" type="checkbox" v-model="showDiskUsageInSidebar"> --
              <span class="mark" v-if="showDiskUsageInSidebar">
                <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.4375 6.42188L0.78125 3.78688L1.62594 2.96875L3.4375 4.74844L7.37406 0.84375L8.21875 1.68312L3.4375 6.42188Z" fill="#545454"/>
                </svg>
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'import'">
        <div class="import__app">
          <div class="profile__content__title">{{ $t('settings.import.title') }} </div>
          <div class="import-content">
            <div class="import-content__taskpal">
              <div class="import-content__app">
                <img
                  :src="require('@/assets/static/images/taskpal.svg')"
                  alt=""
                />
                <p @click="import_open = 'show'">{{ $t('settings.import.restore_backup') }}</p>
              </div>
            </div>
            <div class="import-content__apps">
              <div class="import-content__app todoist">
                <img
                  :src="require('@/assets/static/images/todoist.svg')"
                  alt=""
                />
                <p @click="importData('todoist')">{{ $t('settings.import.import_account') }}</p>
              </div>
              <div class="import-content__app m1">
                <img :src="require('@/assets/static/images/m1.svg')" alt="" />
                <p @click="importData('microsoft')">{{ $t('settings.import.import_account') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="import__data" :class="import_open">
          <div class="setting__title">
            <span @click="import_open = 'close'">
              <svg
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00474 1.00137C7.0052 1.23493 6.92386 1.46128 6.77483 1.64112L2.29659 6.99902L6.6149 12.3669C6.69793 12.4692 6.75994 12.5868 6.79735 12.7131C6.83477 12.8394 6.84686 12.9718 6.83293 13.1028C6.81899 13.2338 6.77931 13.3607 6.71616 13.4763C6.65301 13.5919 6.56764 13.6939 6.46495 13.7764C6.36271 13.8594 6.24506 13.9214 6.11877 13.9588C5.99248 13.9962 5.86004 14.0083 5.72906 13.9944C5.59808 13.9805 5.47115 13.9408 5.35556 13.8776C5.23997 13.8145 5.138 13.7291 5.05551 13.6264L0.227399 7.62877C0.0803748 7.44991 0 7.22555 0 6.99402C0 6.76249 0.0803748 6.53813 0.227399 6.35927L5.22544 0.361619C5.30936 0.2604 5.41242 0.17673 5.52872 0.115402C5.64502 0.0540743 5.77228 0.0162916 5.9032 0.00422096C6.03413 -0.00785065 6.16615 0.00602722 6.2917 0.0450563C6.41726 0.0840855 6.53388 0.1475 6.63489 0.231668C6.74956 0.324686 6.84219 0.441952 6.90614 0.575036C6.97009 0.70812 7.00377 0.853719 7.00474 1.00137Z"
                  fill="#FF8686"
                />
              </svg>
            </span>
            {{ $t('settings.import.title') }}
          </div>
          <div class="import__data__content">
            <div class="information" v-html="$t('settings.import.information')"></div>
            <div class="import-data__select">
              <div class="select-style">
                <label>
                  <select @input="selectList" v-model="import_list">
                    <option value="_" selected disabled>{{ $t('settings.import.select') }}</option>
                    <option
                      v-for="list of lists"
                      :key="list._id"
                      :value="list._id"
                    >
                      {{ list.name }}
                    </option>
                  </select>
                  <img
                    :src="require(`@/assets/static/images/arrow-select.svg`)"
                    alt=""
                  />
                </label>
              </div>
              <svg
                width="73"
                height="18"
                viewBox="0 0 73 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M73 9L58 0.339746V17.6603L73 9ZM0 10.5H59.5V7.5H0V10.5Z"
                  fill="#9F9797"
                />
              </svg>
              <label
                class="button-style"
                :class="
                  import_button_file_text == $t('settings.import.file_button.upload') ? '' : 'disabled'
                "
              >
                <input
                  type="file"
                  @input="fileCheck"
                  :disabled="
                    import_button_file_text == $t('settings.import.file_button.upload') ? false : true
                  "
                  accept=".csv"
                />
                {{ import_button_file_text }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'backups'">
        <div class="profile__content__title">{{ $t('settings.backups.title') }} </div>
        <div class="backup-content">
          <div v-if="getPlan.automatic_daily_backups == 'on'">
            <div v-if="!generateBackupBool" class="backup-content__generate">
              <button @click="generateBackup">Generate</button>
              <p>Click the button to generate a new backup</p>
            </div>
            <div v-else class="backup-content__generate">
              <p style="margin-left: 0">
                The download link will appear below. You can come back later.
              </p>
            </div>
            <div>
              <p class="backup__text">Automatic daily backups (14 days)</p>
              <ul class="backup__list">
                <li v-for="(e, i) in backups" :key="i">
                  <p>{{ renderBackupName(e) }}</p>
                  <div>
                    <!-- <button @click="importBackup(e)" style="margin-right: 15px">Import</button> -->
                    <button @click="downloadBackup(e)">Download</button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="backup-content__backup-text">
            <p>
              <span @click="tab = 'upgrade'">Upgrade</span> your plan to enable
              automatic daily backups
            </p>
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'support'">
        <div class="profile__content__title">{{ $t('settings.support.title') }}</div>
        <div class="support-content">
          <!-- <span
            v-if="showLoader"
            class="image-pre-loader image-pre-loader--red"
          ></span> -->
          <div class="support-form">
            <input type="text" id="subject" :placeholder="$t('settings.support.forms.subject')">
            <input type="email" id="email" :placeholder="$t('settings.support.forms.email')">
            <textarea id="message" :placeholder="$t('settings.support.forms.message')"></textarea>
            <label class="attach-file">
              <img :src="require('@/assets/static/images/clipd.png')" alt=""/>
              <p>{{ $t('settings.support.forms.file') }}</p>
              <input type="file" id="file" @change="supportFile">
            </label>
            <button @click="supportSend">{{ $t('settings.support.forms.button') }}</button>
          </div>
        </div>
      </div>
      <div class="profile__content__block" v-else-if="tab == 'delete-account'">
        <div class="profile__content__title">
          <span @click="tab = 'profile'">
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00474 1.00137C7.0052 1.23493 6.92386 1.46128 6.77483 1.64112L2.29659 6.99902L6.6149 12.3669C6.69793 12.4692 6.75994 12.5868 6.79735 12.7131C6.83477 12.8394 6.84686 12.9718 6.83293 13.1028C6.81899 13.2338 6.77931 13.3607 6.71616 13.4763C6.65301 13.5919 6.56764 13.6939 6.46495 13.7764C6.36271 13.8594 6.24506 13.9214 6.11877 13.9588C5.99248 13.9962 5.86004 14.0083 5.72906 13.9944C5.59808 13.9805 5.47115 13.9408 5.35556 13.8776C5.23997 13.8145 5.138 13.7291 5.05551 13.6264L0.227399 7.62877C0.0803748 7.44991 0 7.22555 0 6.99402C0 6.76249 0.0803748 6.53813 0.227399 6.35927L5.22544 0.361619C5.30936 0.2604 5.41242 0.17673 5.52872 0.115402C5.64502 0.0540743 5.77228 0.0162916 5.9032 0.00422096C6.03413 -0.00785065 6.16615 0.00602722 6.2917 0.0450563C6.41726 0.0840855 6.53388 0.1475 6.63489 0.231668C6.74956 0.324686 6.84219 0.441952 6.90614 0.575036C6.97009 0.70812 7.00377 0.853719 7.00474 1.00137Z"
                fill="#FF8686"
              />
            </svg>
          </span>
          {{ $t('settings.delete_account.title') }}
        </div>
        <div class="delete-account__content">
          <p v-html="$t('settings.delete_account.text')"></p>
          <div>
            <input type="text" ref="delete_account_input">
            <button @click="deleteAccountAction">{{ $t('settings.delete_account.button') }}</button>
          </div>
        </div>
      </div>
      <div
        class="profile__content__block change-password"
        :class="{ show: tab == 'change_password' }"
        :style="{
          transition:
            tab == 'change_password' ||
            tab == 'profile' ||
            tab == 'change_email'
              ? 'all 0.3s ease'
              : 'none',
        }"
      >
        <div class="profile__content__title">
          <span @click="tab = 'profile'">
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00474 1.00137C7.0052 1.23493 6.92386 1.46128 6.77483 1.64112L2.29659 6.99902L6.6149 12.3669C6.69793 12.4692 6.75994 12.5868 6.79735 12.7131C6.83477 12.8394 6.84686 12.9718 6.83293 13.1028C6.81899 13.2338 6.77931 13.3607 6.71616 13.4763C6.65301 13.5919 6.56764 13.6939 6.46495 13.7764C6.36271 13.8594 6.24506 13.9214 6.11877 13.9588C5.99248 13.9962 5.86004 14.0083 5.72906 13.9944C5.59808 13.9805 5.47115 13.9408 5.35556 13.8776C5.23997 13.8145 5.138 13.7291 5.05551 13.6264L0.227399 7.62877C0.0803748 7.44991 0 7.22555 0 6.99402C0 6.76249 0.0803748 6.53813 0.227399 6.35927L5.22544 0.361619C5.30936 0.2604 5.41242 0.17673 5.52872 0.115402C5.64502 0.0540743 5.77228 0.0162916 5.9032 0.00422096C6.03413 -0.00785065 6.16615 0.00602722 6.2917 0.0450563C6.41726 0.0840855 6.53388 0.1475 6.63489 0.231668C6.74956 0.324686 6.84219 0.441952 6.90614 0.575036C6.97009 0.70812 7.00377 0.853719 7.00474 1.00137Z"
                fill="#FF8686"
              />
            </svg>
          </span>
          {{ $t('settings.profile.title') }}
        </div>
        <div
          class="profile__content__form padding-top"
          v-if="getUserData.password"
        >
          <div class="input">
            <label>
              <span class="justify-content_space-between"
                >{{ $t('settings.change_password.forms.old_password') }}
                <p
                  :style="!send_for_got_password ? 'opacity: 0.7' : ''"
                  @click="forgot_password"
                >
                  {{ $t('settings.change_password.forms.forgot_password') }}
                </p></span
              >
              <input type="password" v-model="change_password.old_password" />
            </label>
          </div>
          <div class="input">
            <label>
              <span>{{ $t('settings.change_password.forms.new_password') }}</span>
              <input type="password" v-model="change_password.new_password" />
            </label>
          </div>
          <div class="input">
            <label>
              <span>{{ $t('settings.change_password.forms.confirm_password') }}</span>
              <input
                type="password"
                v-model="change_password.confirm_password"
              />
            </label>
          </div>
          <div class="profile__content__form__flex_btn">
            <button class="red-btn" @click="tab = 'profile'">{{ $t('settings.change_password.forms.cancel') }}</button>
            <button class="blue-btn" @click="saveUserPassword">{{ $t('settings.change_password.forms.button') }}</button>
          </div>
        </div>
        <div class="profile__content__form padding-top" v-else>
          <div class="input">
            <label>
              <span class="justify-content_space-between">{{ $t('settings.change_password.forms.add_password') }}</span>
              <input type="password" v-model="change_password.new_password" />
            </label>
          </div>
          <div class="profile__content__form__flex_btn">
            <button class="red-btn" @click="tab = 'profile'">{{ $t('settings.change_password.forms.cancel') }}</button>
            <button class="blue-btn" @click="addPassword">{{ $t('settings.change_password.forms.button') }}</button>
          </div>
        </div>
      </div>
      <div
        class="profile__content__block change-email"
        :class="{ show: tab == 'change_email' }"
        :style="{
          transition:
            tab == 'change_email' ||
            tab == 'profile' ||
            tab == 'change_password'
              ? 'all 0.3s ease'
              : 'none',
        }"
      >
        <div class="profile__content__title">
          <span @click="tab = 'profile'">
            <svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00474 1.00137C7.0052 1.23493 6.92386 1.46128 6.77483 1.64112L2.29659 6.99902L6.6149 12.3669C6.69793 12.4692 6.75994 12.5868 6.79735 12.7131C6.83477 12.8394 6.84686 12.9718 6.83293 13.1028C6.81899 13.2338 6.77931 13.3607 6.71616 13.4763C6.65301 13.5919 6.56764 13.6939 6.46495 13.7764C6.36271 13.8594 6.24506 13.9214 6.11877 13.9588C5.99248 13.9962 5.86004 14.0083 5.72906 13.9944C5.59808 13.9805 5.47115 13.9408 5.35556 13.8776C5.23997 13.8145 5.138 13.7291 5.05551 13.6264L0.227399 7.62877C0.0803748 7.44991 0 7.22555 0 6.99402C0 6.76249 0.0803748 6.53813 0.227399 6.35927L5.22544 0.361619C5.30936 0.2604 5.41242 0.17673 5.52872 0.115402C5.64502 0.0540743 5.77228 0.0162916 5.9032 0.00422096C6.03413 -0.00785065 6.16615 0.00602722 6.2917 0.0450563C6.41726 0.0840855 6.53388 0.1475 6.63489 0.231668C6.74956 0.324686 6.84219 0.441952 6.90614 0.575036C6.97009 0.70812 7.00377 0.853719 7.00474 1.00137Z"
                fill="#FF8686"
              />
            </svg>
          </span>
          {{ $t('settings.profile.title') }}
        </div>
        <div class="password__text" v-if="!getUserData.password">
          {{ $t('settings.no_password') }}
        </div>
        <div class="profile__content__form padding-top">
          <div class="input">
            <label>
              <span>{{ $t('settings.change_email.forms.new_email') }}</span>
              <input type="text" v-model="change_email.new_email" />
            </label>
          </div>
          <div class="input">
            <label>
              <span>{{ $t('settings.change_email.forms.confirm_email') }}</span>
              <input type="email" v-model="change_email.confirm_email" />
            </label>
          </div>
          <div class="input">
            <label>
              <span class="justify-content_space-between"
                >{{ $t('settings.change_email.forms.password') }}
                <p
                  @click="forgot_password"
                  v-if="getUserData.password"
                  :style="!send_for_got_password ? 'opacity: 0.7' : ''"
                >
                {{ $t('settings.change_email.forms.forgot_password') }}
                </p></span
              >
              <input type="password" v-model="change_email.password" />
            </label>
          </div>
          <div class="profile__content__form__flex_btn">
            <button class="red-btn" @click="tab = 'profile'">{{ $t('settings.change_email.forms.cancel') }}</button>
            <button
              class="blue-btn"
              @click="saveUserEmail"
              v-if="getUserData.password"
            >
            {{ $t('settings.change_email.forms.button') }}
            </button>
            <button class="blue-btn" v-else disabled>{{ $t('settings.change_email.forms.button') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { EventEmitter } from '../../main';
import File from '../../utils/aws';
import passwordValidator from 'password-validator';
import { loadStripe } from '@stripe/stripe-js';
import moment from 'moment';

import Themes from "@/components/app/settings/Themes.vue";

export default {
  data() {
    return {
      activeThemeTab: 'background-image',
      coupon_button_desable: false,
      message_warn: '',
      coupon_id: '',
      new_price: '',
      coupon_code: '',
      send_for_got_password: true,
      lists: [],
      import_list: '',
      import_file: '',
      import_file_name: '',
      import_open: 'none',
      import_button_file_text: this.$t('settings.import.file_button.upload'),
      backups: [],
      generateBackupBool: false,
      showDiskUsageInSidebar: false,
      file: '',
      show_settings: false,
      change_verification: false,
      send_verification: false,
      send_verification_button: true,
      show_password: false,
      tab: '',
      user_name: '',
      pro: 8,
      user_image: '',
      text_file: '',
      business: 22,
      account: this.$t('settings.profile.title'),
      change_email: {
        new_email: '',
        confirm_email: '',
        password: '',
      },
      change_password: {
        old_password: '',
        new_password: '',
        confirm_password: '',
      },
      select: {
        date: '',
        time: '',
        week: '',
        lang: '',
        home: '',
        subtask: '',
        new_task: '',
      },
      checkbox: {
        high_priority: false,
        medium_priority: false,
        assigned_to_me: false,
        today: false,
        inbox: false,
      },
      plans: [],
      stripe: '',
      stripeElements: '',
      formNumber: 0,
      formData: [
        {
          title: 'Add your account details',
        },
        {
          title: 'Add business address',
        },
        {
          title: 'Add payment details',
        },
      ],
      formInputs: {
        email: '',
        name: '',
        shipping: {
          address: {
            city: '',
            country: '',
            line1: '',
            postal_code: '',
            state: '',
          },
          name: '',
        },
        address: {
          city: '',
          country: '',
          line1: '',
          postal_code: '',
          state: '',
        },
      },
      differentShippingAddress: false,
      current_plan: '',
      current_plan_id: '',
      payment_result_message: '',
      isYearlyPlan: false,
      current_subscr_id: '',
      old_plan_name: '',
      hover_plan_id: '',
      real_prices: [],
      showLoader: true,
    };
  },
  components: {Themes},
  computed: {
    ...mapGetters([
      'getUserData',
      'getRenderUserData',
      'getChats',
      'getProjects',
      'getTeams',
      'getUserAllFileSize',
      'getUserUsedFileSize',
      'getPlan',
      'getLists',
      'get_flag_for_tasks',
      'getTasks',
      'getAllPlan',
    ]),
    getChatsExcluded() {
      return this.$store.state['chats'].chats.filter((chat => !this.$store.state.key.excludedData.chats.includes(chat._id)));
    },
    userData() {
      return this.getUserData;
    },
    usageList() {
      let plan = this.getPlan;
      let arr = [];
      arr.push(
        this.createUsageSingle(
          this.$t('settings.usage.members'),
          this.getTeams.length,
          plan.max_users_team
        )
      );
      arr.push(
        this.createUsageSingle(
          this.$t('settings.usage.lists'),
          this.getProjects.filter(
            (e) => e._id != this.getUserData.shortcut_inbox
          ).length,
          plan.lists_max_amount
        )
      );
      arr.push(
        this.createUsageSingle(
          this.$t('settings.usage.folders'),
          this.getUserData.folder.length,
          plan.folders_max_amount
        )
      );
      arr.push(this.createUsageSingle(this.$t('settings.usage.tasks_per_list'), plan.tasks_max_amount));
      arr.push(
        this.createUsageSingle(this.$t('settings.usage.subtasks_per_task'), plan.subtasks_max_amount)
      );
      arr.push(
        this.createUsageSingle(this.$t('settings.usage.sections_per_list'), plan.sections_max_amount)
      );
      arr.push(
        this.createUsageSingle(
          this.$t('settings.usage.chats'),
          this.getChatsExcluded.length,
          plan.chats_max_amount
        )
      );
      arr.push(this.createUsageSingle(this.$t('settings.usage.log_messages'), plan.log_max_amount));
      arr.push(
        this.createUsageSingle(
          this.$t('settings.usage.disk_space'),
          this.$w_parse_doc_size(this.getUserUsedFileSize),
          this.$w_parse_doc_size(this.getUserAllFileSize)
        )
      );
      return arr;
    },
    background_images() {
      return this.$store.state.key.background_images;
    },
    background_image() {
      return this.$store.state.key.background_image;
    },
  },
  watch: {
    send_for_got_password() {
      if (this.send_for_got_password == false) {
        setTimeout(() => {
          this.send_for_got_password = true;
        }, 30000);
      }
    },
    send_verification_button() {
      if (this.send_verification_button == false) {
        setTimeout(() => {
          this.send_verification_button = true;
        }, 30000);
      }
    },
    tab() {
      this.clearImportDataCSV();
      this.import_open = 'none';
      this.change_email.new_email = '';
      this.change_email.confirm_email = '';
      this.change_email.password = '';
      this.change_password.old_password = '';
      this.change_password.new_password = '';
      this.change_password.confirm_password = '';

      if (this.tab == 'support') {
        setTimeout(() => {
          this.showLoader = false;
        }, 5000);
      } else {
        this.showLoader = true;
      }
    },
    getRenderUserData() {
      this.user_image = this.$w_user_image(this.getUserData, 110);

      this.checkbox = {
        high_priority: false,
        medium_priority: false,
        assigned_to_me: false,
        today: false,
        inbox: false,
      };
      this.getUserData.shortcuts.forEach((e) => {
        if (e.type == 'high_priority') {
          this.checkbox.high_priority = true;
        }
        if (e.type == 'medium_priority') {
          this.checkbox.medium_priority = true;
        }
        if (e.type == 'assigned_to_me') {
          this.checkbox.assigned_to_me = true;
        }
        if (e.type == 'today') {
          this.checkbox.today = true;
        }
        if (e.type == 'inbox') {
          this.checkbox.inbox = true;
        }
      });

      setTimeout(() => {
        this.backups = this.getUserData.backups
          ? this.getUserData.backups.reverse()
          : [];

        if (this.getUserData.verification) {
          this.send_verification = false;
          this.account = this.$t('settings.profile.title');
        } else {
          this.account =
            this.$t('settings.profile.title') + ' <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.49996 0.166664C6.85179 0.166664 5.24062 0.655406 3.87021 1.57108C2.4998 2.48676 1.4317 3.78825 0.800967 5.31097C0.170237 6.83369 0.00520889 8.50924 0.326752 10.1258C0.648296 11.7423 1.44197 13.2271 2.60741 14.3926C3.77284 15.558 5.2577 16.3517 6.87421 16.6732C8.49072 16.9948 10.1663 16.8297 11.689 16.199C13.2117 15.5683 14.5132 14.5002 15.4289 13.1298C16.3446 11.7593 16.8333 10.1482 16.8333 8.5C16.8333 6.28986 15.9553 4.17024 14.3925 2.60744C12.8297 1.04464 10.7101 0.166664 8.49996 0.166664V0.166664ZM8.49996 15.4444C7.12648 15.4444 5.78384 15.0372 4.64184 14.2741C3.49983 13.511 2.60974 12.4265 2.08413 11.1575C1.55852 9.88859 1.421 8.49229 1.68895 7.1452C1.95691 5.79811 2.6183 4.56073 3.5895 3.58953C4.5607 2.61834 5.79808 1.95694 7.14517 1.68899C8.49226 1.42104 9.88856 1.55856 11.1575 2.08417C12.4264 2.60978 13.511 3.49986 14.2741 4.64187C15.0371 5.78388 15.4444 7.12652 15.4444 8.5C15.4444 9.41196 15.2648 10.315 14.9158 11.1575C14.5668 12.0001 14.0553 12.7656 13.4104 13.4105C12.7656 14.0553 12 14.5668 11.1575 14.9158C10.3149 15.2648 9.41192 15.4444 8.49996 15.4444V15.4444Z" fill="#F99696"/><path d="M8.49995 9.9375C8.26051 9.9375 8.03089 9.84239 7.86158 9.67308C7.69228 9.50378 7.59717 9.27415 7.59717 9.03472V4.86806C7.59717 4.62862 7.69228 4.399 7.86158 4.2297C8.03089 4.06039 8.26051 3.96528 8.49995 3.96528C8.73938 3.96528 8.969 4.06039 9.13831 4.2297C9.30761 4.399 9.40272 4.62862 9.40272 4.86806V9.03472C9.40272 9.27415 9.30761 9.50378 9.13831 9.67308C8.969 9.84239 8.73938 9.9375 8.49995 9.9375Z" fill="#F99696"/><path d="M8.46525 13.0278C9.04055 13.0278 9.50692 12.5614 9.50692 11.9861C9.50692 11.4108 9.04055 10.9444 8.46525 10.9444C7.88995 10.9444 7.42358 11.4108 7.42358 11.9861C7.42358 12.5614 7.88995 13.0278 8.46525 13.0278Z" fill="#F99696"/></svg>';
        }

        if (this.getUserData.homepage) {
          if (this.getUserData.homepage.type == 'chat') {
            this.getChats.forEach((chat, i) => {
              if (chat._id == this.getUserData.homepage._id) {
                this.select.home = chat._id;
              }
            });
          } else if (this.getUserData.homepage.type == 'project') {
            this.getProjects.forEach((project, i) => {
              if (project._id == this.getUserData.homepage._id) {
                this.select.home = project._id;
              }
            });
          } else {
            this.select.home = this.getUserData.homepage.type;
          }
        }

        if (this.getUserData.language) {
          this.select.lang = this.getUserData.language;
        }

        if (this.getUserData.date_format) {
          if (this.getUserData.date_format.date) {
            this.select.date = this.getUserData.date_format.date;
          }

          if (this.getUserData.date_format.time) {
            this.select.time = this.getUserData.date_format.time;
          }

          if (this.getUserData.date_format.start_of_the_week) {
            this.select.week = this.getUserData.date_format.start_of_the_week;
          }
        }

        // if (this.getUserData.expand_subtask) {
        this.select.subtask = this.getUserData.expand_subtask
          ? 'Enabled'
          : 'Disabled';
        // }

        // if (this.getUserData.new_task) {
        this.select.new_task = this.getUserData.new_task ? 'top' : 'bottom';
        // }

        if (this.getUserData.shortcuts) {
          this.getUserData.shortcuts.forEach((e) => {
            if (e.type == 'high_priority') {
              this.checkbox.high_priority = true;
            }
            if (e.type == 'medium_priority') {
              this.checkbox.medium_priority = true;
            }
            if (e.type == 'assigned_to_me') {
              this.checkbox.assigned_to_me = true;
            }
            if (e.type == 'today') {
              this.checkbox.today = true;
            }
            if (e.type == 'inbox') {
              this.checkbox.inbox = true;
            }
          });
        }
      }, 1000);
    },
    import_open() {
      this.clearImportDataCSV();
      this.lists = [];
      let lists2 = this.getLists['list'] ? this.getLists['list'] : [];
      let folders = this.getLists['folder'] ? this.getLists['folder'] : [];

      this.lists = this.lists.concat(lists2);

      folders.forEach((e) => {
        if (e.lists) {
          e.lists.forEach((a) => {
            this.lists.push(a);
          });
        }
      });
    },
  },
  mounted() {
    this.clearImportDataCSV();
    setTimeout(() => {
      this.showDiskUsageInSidebar = this.getUserData.show_disk_usage;
      if (this.getUserData.backups) {
        this.backups = this.getUserData.backups.reverse();
      }
      this.getAllPlan.forEach((plan) => {
        this.real_prices[plan._id] = plan.price;
      });
    }, 100);

    EventEmitter.$on('SOCKET_OUT_Backups', () => {
      this.generateBackupBool = false;
    });

    EventEmitter.$on('SOCKET_OUT_PlanChanged', (data) => {

      let old_plan_name = data.old_plan_name;
      if (data.default == 'on') {
        let text = `You successfully unsubscribed`;
        if (old_plan_name) {
          text = `You successfully unsubscribed from ${old_plan_name} subscription`;
        }
        let data = {
          data: {
            text: text,
            cancel: 'Close',
          },
        };
        EventEmitter.$emit('OpenPopup', data);
      }

      this.current_plan_id = data._id;
      this.current_plan = data;
    });

    EventEmitter.$on('onShowDiskUsageInSidebarChange', (newVal) => {
      this.showDiskUsageInSidebar = newVal;
    });

    this.current_plan_id = this.getUserData.plan;

    this.user_image = this.$w_user_image(this.getUserData, 110);

    if (this.getUserData.verification) {
      this.account = this.$t('settings.profile.title');;
    } else {
      this.account =
        this.$t('settings.profile.title') + ' <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.49996 0.166664C6.85179 0.166664 5.24062 0.655406 3.87021 1.57108C2.4998 2.48676 1.4317 3.78825 0.800967 5.31097C0.170237 6.83369 0.00520889 8.50924 0.326752 10.1258C0.648296 11.7423 1.44197 13.2271 2.60741 14.3926C3.77284 15.558 5.2577 16.3517 6.87421 16.6732C8.49072 16.9948 10.1663 16.8297 11.689 16.199C13.2117 15.5683 14.5132 14.5002 15.4289 13.1298C16.3446 11.7593 16.8333 10.1482 16.8333 8.5C16.8333 6.28986 15.9553 4.17024 14.3925 2.60744C12.8297 1.04464 10.7101 0.166664 8.49996 0.166664V0.166664ZM8.49996 15.4444C7.12648 15.4444 5.78384 15.0372 4.64184 14.2741C3.49983 13.511 2.60974 12.4265 2.08413 11.1575C1.55852 9.88859 1.421 8.49229 1.68895 7.1452C1.95691 5.79811 2.6183 4.56073 3.5895 3.58953C4.5607 2.61834 5.79808 1.95694 7.14517 1.68899C8.49226 1.42104 9.88856 1.55856 11.1575 2.08417C12.4264 2.60978 13.511 3.49986 14.2741 4.64187C15.0371 5.78388 15.4444 7.12652 15.4444 8.5C15.4444 9.41196 15.2648 10.315 14.9158 11.1575C14.5668 12.0001 14.0553 12.7656 13.4104 13.4105C12.7656 14.0553 12 14.5668 11.1575 14.9158C10.3149 15.2648 9.41192 15.4444 8.49996 15.4444V15.4444Z" fill="#F99696"/><path d="M8.49995 9.9375C8.26051 9.9375 8.03089 9.84239 7.86158 9.67308C7.69228 9.50378 7.59717 9.27415 7.59717 9.03472V4.86806C7.59717 4.62862 7.69228 4.399 7.86158 4.2297C8.03089 4.06039 8.26051 3.96528 8.49995 3.96528C8.73938 3.96528 8.969 4.06039 9.13831 4.2297C9.30761 4.399 9.40272 4.62862 9.40272 4.86806V9.03472C9.40272 9.27415 9.30761 9.50378 9.13831 9.67308C8.969 9.84239 8.73938 9.9375 8.49995 9.9375Z" fill="#F99696"/><path d="M8.46525 13.0278C9.04055 13.0278 9.50692 12.5614 9.50692 11.9861C9.50692 11.4108 9.04055 10.9444 8.46525 10.9444C7.88995 10.9444 7.42358 11.4108 7.42358 11.9861C7.42358 12.5614 7.88995 13.0278 8.46525 13.0278Z" fill="#F99696"/></svg>';
    }

    EventEmitter.$on('OUT_Verification', () => {
      this.change_verification = true;
    });

    EventEmitter.$on('ChangeEmailUser', () => {
      this.tab = 'profile';
      this.change_email.new_email = '';
      this.change_email.confirm_email = '';
      this.change_email.password = '';
    });

    EventEmitter.$on('openSettingPlan', () => {
      this.show_settings = true;
      this.tab = 'upgrade';
    });

    setTimeout(() => {
      if (this.getUserData.homepage) {
        if (this.getUserData.homepage.type == 'chat') {
          this.getChats.forEach((chat, i) => {
            if (chat._id == this.getUserData.homepage._id) {
              this.select.home = chat._id;
            }
          });
        } else if (this.getUserData.homepage.type == 'project') {
          this.getProjects.forEach((project, i) => {
            if (project._id == this.getUserData.homepage._id) {
              this.select.home = project._id;
            }
          });
        } else {
          this.select.home = this.getUserData.homepage.type;
        }
      }

      if (this.getUserData.language) {
        this.select.lang = this.getUserData.language;
      }

      if (this.getUserData.date_format) {
        if (this.getUserData.date_format.date) {
          this.select.date = this.getUserData.date_format.date;
        }

        if (this.getUserData.date_format.time) {
          this.select.time = this.getUserData.date_format.time;
        }

        if (this.getUserData.date_format.start_of_the_week) {
          this.select.week = this.getUserData.date_format.start_of_the_week;
        }
      }

      // if (this.getUserData.expand_subtask) {
      this.select.subtask = this.getUserData.expand_subtask
        ? 'Enabled'
        : 'Disabled';
      // }

      // if (this.getUserData.new_task) {
      this.select.new_task = this.getUserData.new_task ? 'top' : 'bottom';
      // }

      if (this.getUserData.shortcuts) {
        this.getUserData.shortcuts.forEach((e) => {
          if (e.type == 'high_priority') {
            this.checkbox.high_priority = true;
          }
          if (e.type == 'medium_priority') {
            this.checkbox.medium_priority = true;
          }
          if (e.type == 'assigned_to_me') {
            this.checkbox.assigned_to_me = true;
          }
          if (e.type == 'today') {
            this.checkbox.today = true;
          }
          if (e.type == 'inbox') {
            this.checkbox.inbox = true;
          }
        });
      }
    }, 1000);

    // this.select.lang = this.getUserData.language

    this.user_name = this.getUserData.name;

    EventEmitter.$on('openSettings', (data) => {
      this.tab = data;
      this.show_settings = true;
      this.change_verification = false;
    });

    // let lists2 = this.getLists['list'] ? this.getLists['list'] : []
    // let folders = this.getLists['folder'] ? this.getLists['folder'] : []

    // this.lists = this.lists.concat(lists2)

    // folders.forEach(e => {
    //   if (e.lists) {
    //     e.lists.forEach(a => {
    //       this.lists.push(a)
    //     })
    //   }
    // })
  },
  methods: {
    ...mapActions([
      // "fetchUserData",
      'change_user_data',
      'socket_add_project',
      'ForGotPassword',
      'sendStripeQuery',
      'fetch_request',
    ]),
    ...mapMutations([
      'setMessage',
      'setChangeUserData',
      'set_change_password',
      'userDowngradeChange',
      'userBackgoundImageChange',
    ]),
    changeThemeTab(tab) {
      this.activeThemeTab = tab
    },
    async deleteAccountAction() {
      console.log(this.$refs.delete_account_input.value)
      if (this.$refs.delete_account_input.value == 'YES') {
        const req = await this.fetch_request({
          token: true,
          method: "POST",
          url: this.$w_api.DELETE_ACCOUNT_API,
        })
        if (req.status == 200) {
          this.$w_alert(this.$t('settings.delete_account.alert'), [
            {
              buttonText: this.$t('settings.delete_account.alert_button'),
              callback: (close) => {
                close()
              }
            }
          ])
        }
      }
    },
    async uploadBackgroundImage(e) {
      if (e.target.files[0].size < 1050000) {
        if (
          e.target.files[0].type == 'image/jpeg' ||
          e.target.files[0].type == 'image/png' ||
          e.target.files[0].type == 'image/jpg'
        ) {
          this.text_file = this.$t('settings.theme.tabs.background_image.file.uploading');

          const aws = new File(e.target.files[0]);
          let file_name = this.getUserData._id + '_' + e.target.files[0].name;
          let uploadRequest = await aws.write(
            'Users/' + this.getUserData._id + '/background_image/' + file_name
          );

          uploadRequest.on('httpUploadProgress', () => {
            this.text_file = this.$t('settings.theme.tabs.background_image.file.uploading');
          });

          uploadRequest.send((err) => {
            if (err) {
              console.log('FAILURE!!');
            } else {
              this.text_file = '';
              this.changeBackgroundImage({
                image_name: file_name,
              });
            }
          });
        } else {
          this.$w_alert(this.$t('settings.theme.tabs.background_image.file.alert.error_type'), [
            {
              buttonText: this.$t('app.alert.ok'),
              callback: (close) => {
                close();
              },
            },
          ]);
        }
      } else {
        this.$w_alert(this.$t('settings.theme.tabs.background_image.file.alert.error_size'), [
          {
            buttonText: this.$t('app.alert.ok'),
            callback: (close) => {
              close();
            },
          },
        ]);
      }
    },
    async removeBackgroundImage() {
      const image = this.background_images.find((e) => e.default == true);
      const req = await this.fetch_request({
        token: true,
        method: 'POST',
        url: this.$w_api.CHANGE_BACKGROUND_IMAGE,
        body: {
          image_name: image.image_name,
        },
      });
      if (req.ok) {
        const reqJSON = await req.json();
        if (reqJSON.message == 'changed image') {
          this.userBackgoundImageChange(image.image_name);
        }
      }
    },
    async changeBackgroundImage(image) {
      if (
        !this.background_images.some(
          (e) => e.image_name == this.getUserData.background_image
        )
      ) {
        this.$w_alert(
          this.$t('settings.theme.tabs.background_image.file.alert.need_remove_image') + image.title,
          [
            {
              buttonText: this.$t('app.alert.cancel'),
              callback: (close) => {
                close();
              },
            },
            {
              buttonText: this.$t('app.alert.remove'),
              className: 'red',
              callback: async (close) => {
                const req = await this.fetch_request({
                  token: true,
                  method: 'POST',
                  url: this.$w_api.CHANGE_BACKGROUND_IMAGE,
                  body: {
                    image_name: image.image_name,
                  },
                });
                if (req.ok) {
                  const reqJSON = await req.json();
                  if (reqJSON.message == 'changed image') {
                    this.userBackgoundImageChange(image.image_name);
                  }
                }
                close();
              },
            },
          ]
        );
      } else {
        const req = await this.fetch_request({
          token: true,
          method: 'POST',
          url: this.$w_api.CHANGE_BACKGROUND_IMAGE,
          body: {
            image_name: image.image_name,
          },
        });
        if (req.ok) {
          const reqJSON = await req.json();
          if (reqJSON.message == 'changed image') {
            this.userBackgoundImageChange(image.image_name);
          }
        }
      }
    },
    async couponCodeSend() {
      this.message_warn = '';
      this.new_price = '';
      this.coupon_id = '';
      if (this.coupon_code) {
        if (!this.coupon_button_desable) {
          this.coupon_button_desable = true;
          let request = await this.sendStripeQuery({
            url: this.$w_api.STRIPE_COUPON_CHECK,
            body: {
              code: this.coupon_code,
            },
          });
          if (request) {
            this.coupon_id = request.id;
            let num =
              (Number(this.current_plan.price) / 100) *
              Number(request.percent_off);
            num = Number(this.current_plan.price) - num;
            this.new_price = num.toFixed(2);
            this.coupon_button_desable = false;
          } else {
            this.message_warn = 'Coupon not valid';
            this.coupon_button_desable = false;
          }
        }
      }
    },
    clearImportDataCSV() {
      this.import_file = '';
      this.import_file_name = '';
      this.import_list = '_';
      if (document.querySelector('.import-data__select input')) {
        console.log(document.querySelector('.import-data__select input').value);
        document.querySelector('.import-data__select input').value = null;
      }
    },
    async sendImportCSV() {
      if (this.import_list && this.import_file) {
        const aws = new File(this.import_file);

        let uploadRequest = await aws.write(
          'Users/' + this.getUserData._id + '/upload/' + this.import_file_name
        );

        await uploadRequest.on('httpUploadProgress', (event) => {
          this.import_button_file_text = this.$t('settings.import.file_button.importing');
        });

        uploadRequest.send(async (err) => {
          if (err) {
            console.log('FAILURE!!');
          } else {
            document.querySelector('.import-data__select input').value = null;
            this.import_button_file_text = this.$t('settings.import.file_button.done');

            const res = {
              token: true,
              method: 'POST',
              url: this.$w_api.POST_IMPORT_CSV,
              body: {
                file_name: this.import_file_name,
                list_id: this.import_list,
              },
            };
            const req = await this.fetch_request(res);
            if (req.ok) {
              const reqJSON = await req.json();
              if (reqJSON.status == 'ok') {
                this.$w_alert(this.$t('settings.import.alert.finished'), [
                  {
                    buttonText: this.$t('app.alert.ok'),
                    callback: (close) => {
                      this.import_open = 'none';
                      setTimeout(() => {
                        window.location.href = window.location.href;
                      }, 1000);
                      close();
                    },
                  },
                ]);
              } else if (reqJSON.status == 'plan') {
                this.$w_alert(
                  this.$t('settings.import.alert.upgrade_plan'),
                  [
                    {
                      buttonText: this.$t('app.alert.cancel'),
                      className: 'red',
                      callback: (close) => {
                        this.import_open = 'none';
                        close();
                      },
                    },
                    {
                      buttonText: this.$t('app.alert.upgrade'),
                      callback: (close) => {
                        this.import_open = 'none';
                        this.tab = 'upgrade';
                        close();
                      },
                    },
                  ]
                );
              } else if (reqJSON.status == 'File empty') {
                this.$w_alert(this.$t('settings.import.alert.empty_file'), [
                  {
                    buttonText: this.$t('app.alert.close'),
                    callback: (close) => {
                      close();
                    },
                  },
                ]);
              } else {
                this.$w_alert(this.$t('settings.import.alert.incorrect_file_format'), [
                  {
                    buttonText: this.$t('app.alert.ok'),
                    callback: (close) => {
                      close();
                    },
                  },
                ]);
              }
              this.import_button_file_text = this.$t('settings.import.file_button.upload');
              this.import_list = '_';
              this.import_file = null;
              this.import_file_name = '';
            }
          }
        });
      }
    },
    async fileCheck($event) {
      if ($event.target.files[0]) {
        if (
          $event.target.files[0].type == 'text/csv' ||
          $event.target.files[0].type == 'application/vnd.ms-excel'
        ) {
          this.import_file = $event.target.files[0];
          this.import_file_name = $event.target.files[0].name;

          if (this.import_list == '_')
            return document
              .querySelector('.import-data__select .select-style')
              .classList.add('active');
          // console.log(this.getTasks[this.import_list].length)
          if (this.getTasks[this.import_list].length > 0) {
            this.$w_alert(
              this.$t('settings.import.alert.overwritten_tasks'),
              [
                {
                  buttonText: this.$t('app.alert.cancel'),
                  className: 'red',
                  callback: (close) => {
                    $event.target.value = null;
                    close();
                  },
                },
                {
                  buttonText: this.$t('app.alert.proceed'),
                  callback: (close) => {
                    this.sendImportCSV();
                    close();
                  },
                },
              ]
            );
          } else {
            this.sendImportCSV();
          }
        } else {
          this.$w_alert(this.$t('settings.import.alert.incorrect_file_format'), [
            {
              buttonText: this.$t('app.alert.ok'),
              callback: (close) => {
                $event.target.value = null;
                close();
              },
            },
          ]);
        }
      }
    },
    selectList($event) {
      if ($event.target.value) {
        this.import_list = $event.target.value;
        document
          .querySelector('.import-data__select .select-style')
          .classList.remove('active');
        if (!this.import_file) return;
        if (this.getTasks[this.import_list].length > 0) {
          this.$w_alert(
            this.$t('settings.import.alert.overwritten_tasks'),
            [
              {
                buttonText: this.$t('app.alert.cancel'),
                className: 'red',
                callback: (close) => {
                  $event.target.value = null;
                  close();
                },
              },
              {
                buttonText: this.$t('app.alert.proceed'),
                callback: (close) => {
                  this.sendImportCSV();
                  close();
                },
              },
            ]
          );
        } else {
          this.sendImportCSV();
        }
      }
    },
    toggleShowDiskUsageInSidebar() {
      this.change_user_data({
        type: 'showDiskUage',
        value: !this.showDiskUsageInSidebar,
      });
      this.$socket.emit('IN_ShowDiskUsage');
      this.showDiskUsageInSidebar = !this.showDiskUsageInSidebar;
    },
    createUsageSingle(name, current, max) {
      return { name, current, max };
    },
    renderBackupName(e) {
      let date = new Date(e);
      return moment(date).format('YYYY-MM-DD hh:mm');
    },
    // async importBackup(e) {
    //   if (confirm('Import data')) {
    //     const res = {
    //       token: true,
    //       method: "POST",
    //       url: this.$w_api.IMPORT_BACKUP,
    //       body: {
    //         backup_name: e
    //       }
    //     }
    //     const req = await this.fetch_request(res)
    //     if (req.ok) {
    //       const reqJSON = await req.json()
    //     }
    //   }
    // },
    async downloadBackup(e) {
      let date = new Date(e);
      date = moment(date).format('YYYY-MM-DD hh:mm');

      this.$w_downloadFile(
        this,
        this.axios,
        `${this.$w_api.DOWNLOAD_BACKUP}?user_id=${this.getUserData._id}&backup_name=${e}`,
        date + '.zip'
      );
    },
    async generateBackup() {
      this.generateBackupBool = true;
      const res = {
        token: true,
        method: 'POST',
        url: this.$w_api.EXPORT_BACKUP,
        body: '',
      };

      const req = await this.fetch_request(res);

      if (req.ok) {
        //
      }
    },
    urlAvatar() {
      const aws = new File();
      return aws.read(
        'Users/' + this.getUserData._id + '/' + this.getUserData.image
      );
    },
    setYearlyPlan(plan_id) {
      if (!this.isYearlyPlan || this.hover_plan_id != plan_id) {
        let active_btns = document.querySelectorAll(
          '.upgrade-content__item__button button.active'
        );

        if (active_btns) {
          active_btns.forEach((btn) => {
            btn.classList.remove('active');
          });
        }

        event.target.classList.add('active');
        this.hover_plan_id = plan_id;
        this.isYearlyPlan = true;
        this.plans.forEach((plan) => {
          if (plan._id == plan_id) {
            plan.price = this.real_prices[plan._id] * 10;
          }
        });
      }
    },
    setMonthlyPlan(plan_id) {
      if (this.isYearlyPlan || plan_id != this.hover_plan_id) {
        let active_btns = document.querySelectorAll(
          '.upgrade-content__item__button button.active'
        );

        if (active_btns) {
          active_btns.forEach((btn) => {
            btn.classList.remove('active');
          });
        }

        event.target.classList.add('active');
        this.hover_plan_id = plan_id;
        this.isYearlyPlan = false;

        this.plans.forEach((plan) => {
          if (plan._id == plan_id) {
            plan.price = this.real_prices[plan._id];
          }
        });
      }
    },
    async subscribeToPlan(event) {
      let valid = true;

      if (this.formNumber == 0) {
        if (!this.formInputs.name || !this.formNumber.email) {
          if (!this.formInputs.name) {
            valid = false;
            document
              .querySelector('.account_details input[name="name"]')
              .classList.add('invalid');
          } else {
            document
              .querySelector('.account_details input[name="name"]')
              .classList.remove('invalid');
          }

          if (
            !this.formInputs.email ||
            this.formInputs.email != this.userData.email
          ) {
            valid = false;
            document
              .querySelector('.account_details input[name="email"]')
              .classList.add('invalid');
          } else {
            document
              .querySelector('.account_details input[name="email"]')
              .classList.remove('invalid');
          }
        }
      } else if (this.formNumber == 1) {
        if (!this.formInputs.address.city) {
          valid = false;
          document
            .querySelector('.account_details input[name="city"]')
            .classList.add('invalid');
        } else {
          document
            .querySelector('.account_details input[name="city"]')
            .classList.remove('invalid');
        }

        if (!this.formInputs.address.country) {
          valid = false;
          document
            .querySelector('.account_details input[name="country"]')
            .classList.add('invalid');
        } else {
          document
            .querySelector('.account_details input[name="country"]')
            .classList.remove('invalid');
        }

        if (!this.formInputs.address.line1) {
          valid = false;
          document
            .querySelector('.account_details input[name="address"]')
            .classList.add('invalid');
        } else {
          document
            .querySelector('.account_details input[name="address"]')
            .classList.remove('invalid');
        }

        if (!this.formInputs.address.postal_code) {
          valid = false;
          document
            .querySelector('.account_details input[name="postalcode"]')
            .classList.add('invalid');
        } else {
          document
            .querySelector('.account_details input[name="postalcode"]')
            .classList.remove('invalid');
        }

        if (!this.formInputs.address.state) {
          valid = false;
          document
            .querySelector('.account_details input[name="state"]')
            .classList.add('invalid');
        } else {
          document
            .querySelector('.account_details input[name="state"]')
            .classList.remove('invalid');
        }
      }

      if (!valid) {
        event.preventDefault();
        return false;
      }

      this.formNumber++;

      if (this.formNumber == 2) {
        document.querySelectorAll('.account_details')[0].classList.add('hide');
        document.querySelectorAll('.plan_popup')[0].classList.add('active');

        this.formInputs.shipping.name = this.formInputs.name;
        if (!this.differentShippingAddress) {
          this.formInputs.shipping.address = this.formInputs.address;
        }

        let bodyValue = null;
        if (
          this.real_prices[this.current_plan._id] != this.current_plan.price
        ) {
          bodyValue = {
            user_id: this.getUserData._id,
            yearly_subscription_id: this.current_plan.yearly_subscription_id,
            customer: this.formInputs,
          };
        } else {
          bodyValue = {
            user_id: this.getUserData._id,
            monthly_subscription_id: this.current_plan.monthly_subscription_id,
            customer: this.formInputs,
          };
        }

        this.formInputs.shipping.name = this.formInputs.name;
        if (!this.differentShippingAddress) {
          this.formInputs.shipping.address = this.formInputs.address;
        }

        if (this.coupon_id) {
          bodyValue.coupon_id = this.coupon_id;
        }

        let request = await this.sendStripeQuery({
          url: this.$w_api.STRIPE,
          body: bodyValue,
        });

        if (request.subscriptionId) {
          this.current_subscr_id = request.subscriptionId;
        }

        document.querySelectorAll('.plan_popup')[0].classList.add('active');

        const options = {
          clientSecret: request.clientSecret,
          appearance: {},
        };

        // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
        this.stripeElements = this.stripe.elements(options);

        // Create and mount the Payment Element
        const paymentElement = this.stripeElements.create('payment');
        paymentElement.mount('#payment-element');
        document.getElementById('submit').click();
        document.getElementById('submit').addEventListener('click', () => {
          document.getElementById('submit').classList.add('active');
          setTimeout(() => {
            document.getElementById('submit').classList.remove('active');
          }, 1500);
        });
      }
    },
    closeStripePopup() {
      document.querySelectorAll('.stripe_popups')[0].classList.remove('active');
      this.formNumber = 0;
    },
    closeStripePaymentPopup() {
      this.closeStripePopup();
      document.querySelectorAll('.plan_popup')[0].classList.remove('active');
      this.formNumber = 0;
    },
    avatarRemove() {
      let sizes = [70, 110];

      sizes.forEach((e) => {
        const aws = new File();
        let data = aws.remove(
          'Users/' +
            this.getUserData._id +
            '/' +
            e +
            '/' +
            this.getUserData.image
        );
      });
      this.setChangeUserData({
        type: 'change_image',
        image: '',
      });
      this.user_image = this.$w_user_image(this.getUserData, 110);
      this.$socket.emit('IN_UserEdit', {
        type: 'change_image',
        image: '',
      });
    },
    async sendStripeForm() {
      let elements = this.stripeElements;
      const form = document.getElementById('payment-form');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const { error } = await this.stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements,
          confirmParams: {
            return_url:
              window.location.href +
              '?plan_id=' +
              this.current_plan._id +
              '&subscription_id=' +
              this.current_subscr_id,
          },
        });

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const messageContainer = document.querySelector('#error-message');
          messageContainer.textContent = error.message;
        } else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }
      });
    },
    async checkUserSubsription(user_id, plan_id) {
      let request = await this.sendStripeQuery({
        url: this.$w_api.STRIPE_DOWNGRADE_CHECK,
        body: {
          user_id: user_id,
          plan_id: plan_id,
        },
      });
      console.log('downgrade');
      console.log(request);

      if (request.message) {
        // it is a downgrade
        let data = {
          data: {
            text: `Your request was received successfully. Current plan will be switched by "${this.current_plan.name}" plan in the next billing period.`,
            cancel: 'Close',
          },
        };
        EventEmitter.$emit('OpenPopup', data);

        let bodyValue;
        if (
          this.real_prices[this.current_plan._id] != this.current_plan.price
        ) {
          bodyValue = {
            user_id: this.getUserData._id,
            yearly_subscription_id: this.current_plan.yearly_subscription_id,
            customer: this.formInputs,
          };
        } else {
          bodyValue = {
            user_id: this.getUserData._id,
            monthly_subscription_id: this.current_plan.monthly_subscription_id,
            customer: this.formInputs,
          };
        }

        console.log('bodyValue');
        console.log(bodyValue);
        let request = await this.sendStripeQuery({
          url: this.$w_api.STRIPE,
          body: bodyValue,
        });
        console.log('request');
        console.log(request);
        if (request.downgrade_plan) {
          this.userDowngradeChange(request.downgrade_plan);
        }
      } else {
        this.openSubscriptionForm(); // keep going it is not downgrade
      }
    },
    subscribe(plan) {
      this.coupon_code = '';
      this.coupon_id = '';
      this.new_price = '';
      this.message_warn = '';
      if (plan) {
        this.formInputs.email = this.userData.email;
        this.formInputs.name = this.userData.name;
        this.current_plan = plan;

        console.log('current plan');
        console.log(plan);
        console.log('current user data');
        console.log(this.userData);

        this.checkUserSubsription(this.userData._id, plan._id);
      }
    },
    openSubscriptionForm() {
      document.querySelectorAll('.stripe_popups')[0].classList.add('active');
    },
    async unsubscribe(plan) {
      if (plan) {
        this.old_plan_name = plan.name;

        let request = await this.sendStripeQuery({
          url: this.$w_api.STRIPE_PLAN_CANCEL,
          body: {
            user_id: this.userData._id,
          },
        });

        console.log('unsubscribe');
        console.log(request);

        if (request.message) {
          let data = {
            data: {
              text: `Your request was received successfully. "${this.old_plan_name}" plan will be disabled in the next billing period.`,
              cancel: 'Close',
            },
          };
          EventEmitter.$emit('OpenPopup', data);
        }

        // let planData = {
        //   user_id: this.userData._id,
        //   plan_id: 'free',
        // }
        // this.$socket.emit('IN_ChangePlan', planData)
      }
    },
    async fileUpload(e) {
      // console.log(e.target.files[0])
      if (e.target.files[0].size < 4500000) {
        if (
          e.target.files[0].type == 'image/jpeg' ||
          e.target.files[0].type == 'image/png' ||
          e.target.files[0].type == 'image/jpg'
        ) {
          this.text_file = this.$t('settings.profile.file.uploading');

          function resizeImageToSpecificWidth(max, input, cb) {
            var data;
            if (input.files && input.files[0]) {
              var reader = new FileReader();
              reader.onload = function (event) {
                var img = new Image();
                img.onload = function () {
                  if (img.width > max) {
                    var oc = document.createElement('canvas'),
                      octx = oc.getContext('2d');
                    oc.width = img.width;
                    oc.height = img.height;
                    octx.drawImage(img, 0, 0);
                    if (img.width > img.height) {
                      oc.height = (img.height / img.width) * max;
                      oc.width = max;
                    } else {
                      oc.width = (img.width / img.height) * max;
                      oc.height = max;
                    }
                    octx.drawImage(oc, 0, 0, oc.width, oc.height);
                    octx.drawImage(img, 0, 0, oc.width, oc.height);
                    data = oc.toDataURL();
                  } else {
                    // function getBase64(file) {
                    //   return new Promise((resolve, reject) => {
                    //     const reader = new FileReader()
                    //     reader.readAsDataURL(file)
                    //     reader.onload = () => resolve(reader.result)
                    //     reader.onerror = error => reject(error)
                    //   })
                    // }
                    // getBase64(input.files[0]).then(
                    //   data => data = data
                    // )
                    data = input.files[0];
                  }
                  cb(data);
                };
                img.src = event.target.result;
              };
              reader.readAsDataURL(input.files[0]);
            }
          }

          let sizes = [70, 110];
          sizes.forEach((f_size) => {
            resizeImageToSpecificWidth(f_size, e.target, async (data1) => {
              // console.log(data1)
              const aws = new File(data1);
              let data = aws.remove(
                'Users/' +
                  this.getUserData._id +
                  '/' +
                  f_size +
                  '/' +
                  this.getUserData.image
              );
              let uploadRequest = await aws.write(
                'Users/' +
                  this.getUserData._id +
                  '/' +
                  f_size +
                  '/' +
                  e.target.files[0].name
              );

              uploadRequest.on('httpUploadProgress', (event) => {
                this.text_file = this.$t('settings.profile.file.uploading');
              });

              uploadRequest.send((err) => {
                if (err) {
                  console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));
                  console.log('FAILURE!!');
                } else {
                  this.text_file = '';

                  localStorage.removeItem(this.getUserData._id);

                  localStorage.setItem(this.getUserData._id, data1);

                  this.$socket.emit('IN_UserEdit', {
                    type: 'change_image',
                    image: e.target.files[0].name,
                  });
                }
              });
            });
          });
        } else {
          this.$w_alert(this.$t('settings.profile.file.alert.type_file'), [
            {
              buttonText: this.$t('app.alert.ok'),
              callback: (close) => {
                close();
              },
            },
          ]);
        }
      } else {
        this.$w_alert(this.$t('settings.profile.file.alert.max_size_file'), [
          {
            buttonText: this.$t('app.alert.ok'),
            callback: (close) => {
              close();
            },
          },
        ]);
      }
    },
    importData(type) {
      let domain_url = process.env.VUE_APP_FRONTEND;
      // let domain_url = 'http://192.168.10.207:5050/'
      if (type == 'todoist') {
        window.open(
          `https://todoist.com/oauth/authorize?client_id=${process.env.VUE_APP_TODOIST_CLIENT_ID}&state=${process.env.VUE_APP_TODOIST_STATE}&scope=data:read&redirect_uri=${domain_url}todoist/`,
          type,
          'width=1250,height=800'
        );
      } else if (type == 'microsoft') {
        window.open(
          `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=46b20944-f5b8-4544-984f-e65a6f294d90&scope=https://graph.microsoft.com/Tasks.ReadWrite&response_type=code&redirect_uri=${domain_url}/microsoft`,
          type,
          'width=1250,height=800'
        );
      }
    },
    changeBox(e) {
      let array = [];

      if (this.checkbox.inbox) {
        let project_id = this.getUserData.shortcut_inbox;
        if (!this.getUserData.shortcut_inbox) {
          project_id = this.$w_decrypt(this.getUserData._id);
          EventEmitter.$emit('InboxAdd', project_id);
          this.socket_add_project({
            name: 'Inbox',
            _id: project_id,
          });
        } else if (this.getProjects.length > 0) {
          let list = this.getProjects.filter(
            (e) => e._id == this.getUserData.shortcut_inbox
          );
          if (list.length == 0) {
            project_id = this.$w_decrypt(this.getUserData._id);
            EventEmitter.$emit('InboxAdd', project_id);
            this.socket_add_project({
              name: 'Inbox',
              _id: project_id,
            });
          }
        }
        array.push({ type: 'inbox', color: '#B86A6F', project_id: project_id });
      }

      if (this.checkbox.today) {
        array.push({ type: 'today', color: '#F2A7A7' });
      }

      if (this.checkbox.assigned_to_me) {
        array.push({ type: 'assigned_to_me', color: '#E3B5B5' });
      }

      if (this.checkbox.medium_priority) {
        array.push({ type: 'medium_priority', color: '#E8CCA2' });
      }

      if (this.checkbox.high_priority) {
        array.push({ type: 'high_priority', color: '#FC8785' });
      }

      this.$socket.emit('IN_Shortcuts', array);
    },
    nowDay() {
      let now = new Date();
      return now.getDate();
    },
    shortcuts(e) {
      if (e == 'high_priority') {
        return this.$t('app.shortcuts.high_priority');
      }
      if (e == 'medium_priority') {
        return this.$t('app.shortcuts.medium_priority');
      }
      if (e == 'assigned_to_me') {
        return this.$t('app.shortcuts.assigned_to_me');
      }
      if (e == 'today') {
        return this.$t('app.shortcuts.today');
      }
      if (e == 'inbox') {
        return this.$t('app.shortcuts.inbox');
      }
    },
    closeSettings() {
      this.clearImportDataCSV();
      this.show_settings = false;
      this.change_email.new_email = '';
      this.change_email.confirm_email = '';
      this.change_email.password = '';
      this.change_password.old_password = '';
      this.change_password.new_password = '';
      this.change_password.confirm_password = '';
    },
    saveUserName() {
      if (this.user_name != '') {
        if (this.user_name.length < 3) {
          this.setMessage({
            key_message: 'warning',
            message: this.$t('settings.profile.forms.name.messages.length_should'),
          });
          return;
        }
        if (this.user_name.length > 25) {
          this.setMessage({
            key_message: 'warning',
            message: this.$t('settings.profile.forms.name.messages.length_should'),
          });
          return;
        }
        this.$socket.emit('IN_UserEdit', {
          type: 'change_name',
          name: this.user_name,
        });
        this.change_user_data({
          type: 'name',
          name: this.user_name,
        });
      }
    },
    saveUserEmail() {
      if (
        this.change_email.new_email &&
        this.change_email.confirm_email &&
        this.change_email.password
      ) {
        if (this.change_email.new_email == this.change_email.confirm_email) {
          if (this.change_email.new_email == this.getUserData.email) {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.email.messages.same_previous'),
            });
            return;
          }
          this.tab = 'profile';
          this.send_verification = true;
          this.send_verification_button = false;
          this.account =
            this.$t('settings.profile.title') + ' <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.49996 0.166664C6.85179 0.166664 5.24062 0.655406 3.87021 1.57108C2.4998 2.48676 1.4317 3.78825 0.800967 5.31097C0.170237 6.83369 0.00520889 8.50924 0.326752 10.1258C0.648296 11.7423 1.44197 13.2271 2.60741 14.3926C3.77284 15.558 5.2577 16.3517 6.87421 16.6732C8.49072 16.9948 10.1663 16.8297 11.689 16.199C13.2117 15.5683 14.5132 14.5002 15.4289 13.1298C16.3446 11.7593 16.8333 10.1482 16.8333 8.5C16.8333 6.28986 15.9553 4.17024 14.3925 2.60744C12.8297 1.04464 10.7101 0.166664 8.49996 0.166664V0.166664ZM8.49996 15.4444C7.12648 15.4444 5.78384 15.0372 4.64184 14.2741C3.49983 13.511 2.60974 12.4265 2.08413 11.1575C1.55852 9.88859 1.421 8.49229 1.68895 7.1452C1.95691 5.79811 2.6183 4.56073 3.5895 3.58953C4.5607 2.61834 5.79808 1.95694 7.14517 1.68899C8.49226 1.42104 9.88856 1.55856 11.1575 2.08417C12.4264 2.60978 13.511 3.49986 14.2741 4.64187C15.0371 5.78388 15.4444 7.12652 15.4444 8.5C15.4444 9.41196 15.2648 10.315 14.9158 11.1575C14.5668 12.0001 14.0553 12.7656 13.4104 13.4105C12.7656 14.0553 12 14.5668 11.1575 14.9158C10.3149 15.2648 9.41192 15.4444 8.49996 15.4444V15.4444Z" fill="#F99696"/><path d="M8.49995 9.9375C8.26051 9.9375 8.03089 9.84239 7.86158 9.67308C7.69228 9.50378 7.59717 9.27415 7.59717 9.03472V4.86806C7.59717 4.62862 7.69228 4.399 7.86158 4.2297C8.03089 4.06039 8.26051 3.96528 8.49995 3.96528C8.73938 3.96528 8.969 4.06039 9.13831 4.2297C9.30761 4.399 9.40272 4.62862 9.40272 4.86806V9.03472C9.40272 9.27415 9.30761 9.50378 9.13831 9.67308C8.969 9.84239 8.73938 9.9375 8.49995 9.9375Z" fill="#F99696"/><path d="M8.46525 13.0278C9.04055 13.0278 9.50692 12.5614 9.50692 11.9861C9.50692 11.4108 9.04055 10.9444 8.46525 10.9444C7.88995 10.9444 7.42358 11.4108 7.42358 11.9861C7.42358 12.5614 7.88995 13.0278 8.46525 13.0278Z" fill="#F99696"/></svg>';
          this.$socket.emit('IN_UserEdit', {
            type: 'change_email',
            email: this.change_email.new_email,
            password: this.change_email.password,
          });
        } else {
          this.setMessage({
            key_message: 'warning',
            message: this.$t('settings.profile.forms.email.messages.not_match'),
          });
        }
      } else {
        this.setMessage({
          key_message: 'warning',
          message: this.$t('settings.profile.forms.email.messages.empty'),
        });
      }
    },
    addPassword() {
      if (this.change_password.new_password) {
        var schema = new passwordValidator();
        schema
          .is()
          .min(8)
          .is()
          .max(100)
          .is()
          .not()
          .oneOf([
            'Passw0rd',
            'Password123',
            '123456',
            'password',
            '12345678',
            'qwerty',
            '123456789',
            '12345',
            '1234',
            '111111',
            '1234567',
            'dragon',
            '123123',
            'baseball',
            'abc123',
            'football',
            'monkey',
            'letmein',
            '696969',
            'shadow',
            'master',
            '666666',
            'qwertyuiop',
            '123321',
            'mustang',
            '1234567890',
            'michael',
            '654321',
            'pussy',
            'superman',
            '1qaz2wsx',
            '7777777',
            'fuckyou',
            '121212',
            '000000',
            'qazwsx',
            '123qwe',
            'killer',
            'trustno1',
            'jordan',
            'jennifer',
            'zxcvbnm',
            'asdfgh',
            'hunter',
            'buster',
            'soccer',
            'harley',
            'batman',
            'andrew',
            'tigger',
            'sunshine',
            'iloveyou',
            'fuckme',
            '2000',
            'charlie',
            'robert',
            'thomas',
            'hockey',
            'ranger',
            'daniel',
            'starwars',
            'klaster',
            '112233',
            'george',
            'asshole',
            'computer',
            'michelle',
            'jessica',
            'pepper',
            '1111',
            'zxcvbn',
            '555555',
            '11111111',
            '131313',
            'freedom',
            '777777',
            'pass',
            'fuck',
            'maggie',
            '159753',
            'aaaaaa',
            'ginger',
            'princess',
            'joshua',
            'cheese',
            'amanda',
            'summer',
            'love',
            'ashley',
            '6969',
            'nicole',
            'chelsea',
            'biteme',
            'matthew',
            'access',
            'yankees',
            '987654321',
            'dallas',
            'austin',
            'thunder',
            'taylor',
            'matrix',
          ]);
        let valid = schema.validate(this.change_password.new_password, {
          list: true,
        });
        if (valid.length > 0) {
          if (valid[0] == 'min') {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.min'),
            });
            return;
          }
          if (valid[0] == 'max') {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.max'),
            });
            return;
          }
          if (valid[0] == 'uppercase') {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.big'),
            });
            return;
          }
          if (valid[0] == 'lowercase') {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.small'),
            });
            return;
          }
          if (valid[0] == 'digits') {
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.num'),
            });
            return;
          }
          if (valid[0] == 'spaces') {
            this.password_message = this.$t('settings.profile.forms.password.messages.space');
            this.setMessage({
              key_message: 'warning',
              message: this.$t('settings.profile.forms.password.messages.space'),
            });
            return;
          }
          if (valid[0] == 'oneOf') {
            this.setMessage({
              key_message: 'warning',
              message:
                this.$t('settings.profile.forms.password.messages.easy'),
            });
            return;
          }
        }

        this.set_change_password();
        this.$socket.emit('IN_UserEdit', {
          type: 'add_password',
          password: this.change_password.new_password,
        });
      } else {
        this.setMessage({
          key_message: 'warning',
          message: this.$t('settings.profile.forms.password.messages.empty'),
        });
      }
    },
    saveUserPassword() {
      if (
        this.change_password.old_password &&
        this.change_password.new_password &&
        this.change_password.confirm_password
      ) {
        if (
          this.change_password.new_password ==
          this.change_password.confirm_password
        ) {
          var schema = new passwordValidator();
          schema
            .is()
            .min(8)
            .is()
            .max(100)
            .is()
            .not()
            .oneOf([
              'Passw0rd',
              'Password123',
              '123456',
              'password',
              '12345678',
              'qwerty',
              '123456789',
              '12345',
              '1234',
              '111111',
              '1234567',
              'dragon',
              '123123',
              'baseball',
              'abc123',
              'football',
              'monkey',
              'letmein',
              '696969',
              'shadow',
              'master',
              '666666',
              'qwertyuiop',
              '123321',
              'mustang',
              '1234567890',
              'michael',
              '654321',
              'pussy',
              'superman',
              '1qaz2wsx',
              '7777777',
              'fuckyou',
              '121212',
              '000000',
              'qazwsx',
              '123qwe',
              'killer',
              'trustno1',
              'jordan',
              'jennifer',
              'zxcvbnm',
              'asdfgh',
              'hunter',
              'buster',
              'soccer',
              'harley',
              'batman',
              'andrew',
              'tigger',
              'sunshine',
              'iloveyou',
              'fuckme',
              '2000',
              'charlie',
              'robert',
              'thomas',
              'hockey',
              'ranger',
              'daniel',
              'starwars',
              'klaster',
              '112233',
              'george',
              'asshole',
              'computer',
              'michelle',
              'jessica',
              'pepper',
              '1111',
              'zxcvbn',
              '555555',
              '11111111',
              '131313',
              'freedom',
              '777777',
              'pass',
              'fuck',
              'maggie',
              '159753',
              'aaaaaa',
              'ginger',
              'princess',
              'joshua',
              'cheese',
              'amanda',
              'summer',
              'love',
              'ashley',
              '6969',
              'nicole',
              'chelsea',
              'biteme',
              'matthew',
              'access',
              'yankees',
              '987654321',
              'dallas',
              'austin',
              'thunder',
              'taylor',
              'matrix',
            ]);
          let valid = schema.validate(this.change_password.new_password, {
            list: true,
          });
          if (valid.length > 0) {
            if (valid[0] == 'min') {
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.min'),
              });
              return;
            }
            if (valid[0] == 'max') {
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.max'),
              });
              return;
            }
            if (valid[0] == 'uppercase') {
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.big'),
              });
              return;
            }
            if (valid[0] == 'lowercase') {
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.small'),
              });
              return;
            }
            if (valid[0] == 'digits') {
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.num'),
              });
              return;
            }
            if (valid[0] == 'spaces') {
              this.password_message = this.$t('settings.profile.forms.password.messages.space');
              this.setMessage({
                key_message: 'warning',
                message: this.$t('settings.profile.forms.password.messages.space'),
              });
              return;
            }
            if (valid[0] == 'oneOf') {
              this.setMessage({
                key_message: 'warning',
                message:
                  this.$t('settings.profile.forms.password.messages.easy'),
              });
              return;
            }
          }
          this.set_change_password();
          this.$socket.emit('IN_UserEdit', {
            type: 'change_password',
            new_password: this.change_password.confirm_password,
            password: this.change_password.old_password,
          });
        } else {
          this.setMessage({
            key_message: 'warning',
            message: this.$t('settings.profile.forms.password.messages.not_match'),
          });
        }
      } else {
        this.setMessage({
          key_message: 'warning',
          message: this.$t('settings.profile.forms.password.messages.empty'),
        });
      }
    },
    saveSettings(e) {
      if (e == 'date_format') {
        this.$socket.emit('IN_UserGeneralSettings', {
          type: 'date_format',
          field: this.select.date,
        });
      } else if (e == 'time_format') {
        this.$socket.emit('IN_UserGeneralSettings', {
          type: 'time_format',
          field: this.select.time,
        });
      } else if (e == 'start_of_the_week') {
        this.$socket.emit('IN_UserGeneralSettings', {
          type: 'start_of_the_week',
          field: this.select.week,
        });
      } else if (e == 'shortcuts') {
        let array = [];

        if (this.select.home == 'inbox') {
          let project_id = this.getUserData.shortcut_inbox;
          if (!this.getUserData.shortcut_inbox) {
            project_id = this.$w_decrypt(this.getUserData._id);
            EventEmitter.$emit('InboxAdd', project_id);
            this.socket_add_project({
              name: 'Inbox',
              _id: project_id,
            });
          } else if (this.getProjects.length > 0) {
            let list = this.getProjects.filter(
              (e) => e._id == this.getUserData.shortcut_inbox
            );
            if (list.length == 0) {
              project_id = this.$w_decrypt(this.getUserData._id);
              EventEmitter.$emit('InboxAdd', project_id);
              this.socket_add_project({
                name: 'Inbox',
                _id: project_id,
              });
            }
          }
          array = { type: 'inbox', color: '#B86A6F', project_id: project_id };
        } else if (this.select.home == 'today') {
          array = { type: 'today' };
        } else if (this.select.home == 'assigned_to_me') {
          array = { type: 'assigned_to_me' };
        } else if (this.select.home == 'medium_priority') {
          array = { type: 'medium_priority' };
        } else if (this.select.home == 'high_priority') {
          array = { type: 'high_priority' };
        } else {
          this.getProjects.forEach((project, i) => {
            if (project._id == this.select.home) {
              array = { type: 'project', _id: project._id };
            }
          });
          this.getChats.forEach((chat, i) => {
            if (chat._id == this.select.home) {
              array = { type: 'chat', _id: chat._id };
            }
          });
        }

        this.$socket.emit('IN_UserGeneralSettings', {
          type: 'homepage',
          field: array,
        });
      } else if (e == 'language') {
        this.select.lang = this.select.lang
        localStorage.setItem('language', this.select.lang);
        this.$i18n.locale = this.select.lang
        this.$socket.emit('IN_UserGeneralSettings', {
          type: e,
          field: this.select.lang,
        });
      } else if (e == 'expand_subtask') {
        this.$socket.emit('IN_UserGeneralSettings', {
          type: e,
          field: this.select.subtask == 'Enabled' ? true : false,
        });
      } else if (e == 'new_task') {
        this.$socket.emit('IN_UserGeneralSettings', {
          type: e,
          field: this.select.new_task == 'top' ? true : false,
        });
      }
    },
    Verification() {
      if (this.send_verification_button) {
        this.send_verification_button = false;
        this.send_verification = true;
        this.$socket.emit('IN_SendVerification');
      }
    },
    async forgot_password() {
      if (this.send_for_got_password) {
        this.send_for_got_password = false;
        const res = {
          url: this.$w_api.ForGotPassword,
          body: {
            email: this.getUserData.email,
          },
        };

        const req = await this.ForGotPassword(res);

        if (req) {
          this.$w_alert(req, [
            {
              buttonText: 'OK',
              className: 'blue',
              callback: (close) => {
                close();
              },
            },
          ]);
        }
      }
    },
    supportFile(e) {
      if (e.target.files.length > 0) {

        const MAX_FILE_SIZE = 5 * 1024 * 1024
        const ALLOWED_FORMATS = ['zip', 'jpeg', 'png', 'jpg']

        let file = e.target.files[0]

        document.querySelector('.attach-file p').innerText = this.$t('settings.support.forms.file')

        if (file.size > MAX_FILE_SIZE) {
          this.setMessage({
            key_message: "warning",
            message: this.$t('settings.support.forms.messages.size')
          })
          e.target.value = ""
          return
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!ALLOWED_FORMATS.includes(fileExtension)) {
          this.setMessage({
            key_message: "warning",
            message: `${this.$t('settings.support.forms.messages.format_invalid')} ${ALLOWED_FORMATS.join(', ')}.`
          })
          e.target.value = ""
          return
        }

        document.querySelector('.attach-file p').innerText = e.target.files[0].name
      }
      
    },
    supportSend() {
  
      let email = document.querySelector('.support-form #email')
      let subject = document.querySelector('.support-form #subject')
      let message = document.querySelector('.support-form #message')
      let file = document.querySelector('.support-form #file')

      if (subject.value == '') {
        this.setMessage({
          key_message: "warning",
          message: this.$t('settings.support.forms.messages.subject_empty')
        })
        return
      }

      if (email.value == '') {
        this.setMessage({
          key_message: "warning",
          message: this.$t('settings.support.forms.messages.email_empty')
        })
        return
      }

      if (!this.$w_email_validate(email.value)) {
        this.setMessage({
          key_message: "warning",
          message: this.$t('settings.support.forms.messages.invalid_email')
        })
        return
      }

      if (message.value == '') {
        this.setMessage({
          key_message: "warning",
          message: this.$t('settings.support.forms.messages.message_empty')
        })
        return
      }

      // Создаем объект FormData
      const formData = new FormData();

      // Добавляем данные формы
      formData.append('your-subject', subject.value);
      formData.append('your-email', email.value);
      formData.append('your-message', message.value);

      // Добавляем файл
      if (file.files.length > 0) {
        formData.append('file-712', file.files[0]); // Добавляем файл
      }

      // Отправляем запрос
      fetch('https://taskpal.com/wp-json/custom-cf7/v1/submit', {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.message === 'ok') {
            this.setMessage({
              key_message: "warning",
              message: this.$t('settings.support.forms.messages.thank_you')
            })
            subject.value = ''
            email.value = ''
            message.value = ''
            file.files = []
          } else {
            console.error('Ошибка отправки:', data.message);
            this.setMessage({
              key_message: "warning",
              message: this.$t('settings.support.forms.messages.error')
            })
          }
        })
        .catch(error => {
          this.setMessage({
            key_message: "warning",
            message: this.$t('settings.support.forms.messages.thank_you')
          })
          subject.value = ''
          email.value = ''
          message.value = ''
          file.files = []
          console.error('Ошибка:', error.message)
        });

    }
  },
  async created() {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
    // console.log('Stripe')
    // console.log(this.stripe)

    // collect data from Stripe
    const clientSecret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    );
    let plan_id = new URLSearchParams(window.location.search).get('plan_id'),
      subscription_id = new URLSearchParams(window.location.search).get(
        'subscription_id'
      );

    // console.log(plan_id, this.current_plan_id)
    if (clientSecret && plan_id != undefined) {
      // Retrieve the PaymentIntent
      this.stripe
        .retrievePaymentIntent(clientSecret)
        .then(({ paymentIntent }) => {
          // const message = document.querySelector('#message')

          // Inspect the PaymentIntent `status` to indicate the status of the payment
          // to your customer.
          //
          // Some payment methods will [immediately succeed or fail][0] upon
          // confirmation, while others will first enter a `processing` state.
          //
          // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
          switch (paymentIntent.status) {
            case 'succeeded':
              // console.log('Success! Payment received.');
              let plan_name = '';
              this.plans.forEach((plan) => {
                if (plan._id == plan_id) {
                  plan_name = plan.name;
                }
              });
              this.payment_result_message = `You’ve purchased a ${plan_name} subscription successfully!`;

              // this.current_plan_id = plan_id
              let planData = {
                user_id: this.userData._id,
                plan_id: plan_id,
                subscription_id: subscription_id,
              };
              this.$socket.emit('IN_ChangePlan', planData);
              // console.log('success plan change request')
              // console.log(planData)

              this.show_settings = true;
              this.tab = 'upgrade';
              break;

            case 'processing':
              // console.log("Payment processing. We'll update you when payment is received.");
              this.payment_result_message =
                "Payment processing. We'll update you when payment is received.";
              break;

            case 'requires_payment_method':
              // console.log('Payment failed. Please try another payment method.');
              this.payment_result_message =
                'Payment failed. Please try another payment method.';
              // Redirect your user back to your payment page to attempt collecting
              // payment again
              break;

            default:
              // console.log('Something went wrong.');
              this.payment_result_message = 'Something went wrong.';
              break;
          }

          let data = {
            data: {
              text: this.payment_result_message,
              cancel: 'Close',
            },
          };
          EventEmitter.$emit('OpenPopup', data);
        });
    }
  },
};
</script>

<style lang="scss">
.change-password,
.change-email {
  position: absolute !important;
  transform: translateX(calc(100% + 197px));
  // transition: all 0.3s ease;

  &.show {
    transform: translateX(197px);
  }
  &.hideNow {
    transition: none !important;
  }
}

.profile-content {
  transition: all 0.3s ease;
  transform: translateX(-100%);
  z-index: 5;

  &.show {
    transform: translateX(0);
  }
}
</style>
